export default {
    en: {
        comingSoon: "Coming soon...",
        goToTop: "To top",
        appVersionTitle: "Version",
        btnOk: "OK",
        btnAccept: "Accept",
        btnAdd: "Add",
        btnAdded: "Added",
        btnBack: "Back",
        btnCopy: "Copy",
        btnSave: "Save",
        btnSend: "Send",
        btnShow: "Show",
        btnView: "View",
        btnEdit: "Edit",
        btnClose: "Close",
		btnRoles: "Roles",
        btnCreate: "Create",
        btnUpload: "Upload",
        btnUpdate: "Update",
        btnDelete: "Delete",
        btnCancel: "Cancel",
        btnExport: "Export data",
		btnMediaExport: "Export media files",
		btnFilter: "Filter",
        btnRemove: "Remove",
		btnSearch: "Search",
		btnDownload: "Download",
        btnSaveSend: "Save and Send",
        btnSettings: "Settings",
        btnExporting: "Exporting",
        btnLeavePage: "Leave the page",
        btnXlsExport: "Export to Excel",
		btnPdfExport: "Export to PDF",
		btnSaveLogic: "Save logic",
        btnShowResults: "Results",
		btnFilterCancel: "Remove filters",
		btnShowLogResults: "Show logs",
		btnShowDiagResults: "Show diagnostics",
        btnNewPwdRequired: "Request a new password",
        btnBackToTheLogin: "Back to login page",
		closeWindowText: "Close window",
		aServiceIsNotWorking: "We're sorry, but this service is not working at the moment.",
        btnBackToTheMainPage: "Back to main page",
        validateAttentionText: "Attention! I have encountered the following problem(s):",
        validateErrorNameText: "The name must contain a space and be at least 5 characters long.",
        validateNullNameText: "The name field cannot be empty.",
        validateNullRoleText: "Please select a user group",
        validateErrorEmailText: "Please enter a valid email address",
        validateNullEmailText: "Please enter an email address",
        validateErrorPasswordText: "The password must be between 8 and 40 characters long and contain upper and lower case letters, numbers and special characters.",
        validateNullPasswordText: "Please enter a password",
        validateNotEqualPasswordsText: "The passwords do not match",
        validateLoginWrongAccount: "Incorrect E-mail or password",
        validateForgotPasswordWrongText: "No user is associated with this email address.",
        defaults: {
			all: "All",
			days: "day(s)",
			exit: "Exit",
			bytes: "bytes",
			enter: "Enter",
			best: "Best",
			items: "items",
			middle: "Middle",
			low: "Low",
			email: "Email address",
			daily: "Daily",
			weekly: "Weekly",
			monthly: "Monthly",
			noResult: "No matches were found for the criteria you entered.",
			landscape: "Landscape view",
			portrait: "Portrait view",
			content: "Content",
			everyone: "Everyone",
			anything: "anything",
			initMaps: "Initializing the map, please wait...",
            initializing: "Initializing, please wait...",
            addAllFields: "Please complete all fields",
            confirm: "Confirmation",
            loading: "Loading, please wait...",
			removed: "Removed",
            uploading: "Uploading and importing, please wait...",
			unlimited: "unlimited",
			text403: "You are not authorised to view the requested page.",
			title403: "Privilege error",
			text404: "The page you are looking for was not found.",
			title404: "Oops! You're lost.",
			text429: "The server is overloaded due to too many requests. Please wait a minute and try again.",
			title429: "Too many requests",
			disabled: "Disabled",
            required: "Required",
			optional: "Optional",
			mandatory: "Mandatory",
			notRequired: "Not required",
			registerDate: "Registration date",
			details: "Details",
			message: "Message",
			fileName: "File name",
			attention: "Attention!",
            operation: "Operation",
			moreOptions: "More options",
            updatedField: "Updated date",
			addNumberHolder: "Enter a number",
            footerText: "Centre for Social Sciences",
            pleaseSelect: "Please select...",
			serverError: "Server-side error",
			latitude: "Latitude",
			longitude: "Longitude",
			fieldSoText: "so",
			fieldMeterText: "meter",
			fieldHourText: "hour(s)",
			fieldMinuteText: "minute(s)",
			fieldSecondText: "second(s)",
			lastUpdaterText: "Updater",
			fileNotFoundText: "File not found.",
			lastModifiedText: "Last updated",
			fieldMinutesPerText: "minutes per",
			fieldElapsedTimeText: "Elapsed time",
			fieldTimeIncreaseText: "Time increase per",
			chooseTheOptions: "Choose from the options",
			activedModuleText: "Active module:",
			clickMeToEditText: "Click here to edit!",
			infoCardEditText: "Click here to edit the info cards!",
			uploadPHImageText: "Choose an image file (svg, jpg, png)",
			fromWebText: "From web",
			fromMobileText: "From mobile",
			createdBy: "Created: ",
			createdFile: "Created file name: ",
			gotoTheMainPage: "Back to the main page",
			failUpdate: "Please fill in all required fields before saving.",
			selectAnOption: "Select an option",
			defaultUploadPicText: "The uploaded image",
            wrongFileFormat: "Invalid file format!",
			wrongScreenSize: "Recommended resolution to use the system: HD (1920x1080px)",
			successImageUpload: "The image has been uploaded successfully.",
            successSaveProcess: "Saved successfully.",
			successCreateProcess: "Created successfully.",
			successUpdateProcess: "Updated successfully.",
			successDeleteProcess: "Successfully removed.",
			successDraggedProcess: "Moved successfully.",
			downloadStartProcessText: "The download has started, please wait...",
			filteredResultNumberText: "Filtering by the number of hits:",
			errorMultipleSelectNotNull: "The drop-down box must contain at least one item!",
			cannotLogoutFromNewSurvey: "Attention! While you are editing the basic data of a new survey, you cannot leave the system!",
			cannotLogoutFromNewProject: "Attention! As long as you do not save when editing the basic data of a new project, you cannot leave the system!",
			filters: {
				elem: "element",
                elements: "elements",
				mediaTypes: "Choose a media type",
				filterText: "Enter a keyword or filter condition...",
				loadedNums: "The number of loaded users ",
				loadedResps: "The number of loaded respondents: ",
				elemPerPage: "items / page",
				removeFilterText: "Are you sure you want to delete the filters you have set?",
				removeFilterTitle: "Confirm deletion of set filters",
			}
        },
        days: {
            monday: "Monday",
            tuesday: "Tuesday",
            wednesday: "Wednesday",
            thrusday: "Thursday",
            friday: "Friday",
            saturday: "Saturday",
            sunday: "Sunday"
        },
        statuses: {
            active: "Active",
            deactive: "Inactive",
        },
        regVerifier: {
            name: "Register verifier",
            process: "Checking, please wait...",
            successMessage: "Your registration has been successfully confirmed!"
        },
        usersTable: {
            titleName: "Name",
            titleEmail: "Email",
            titleAddTo: "Add to project",
            titleRegTo: "Send registration email"
        },
        login: {
            title: "Login",
            text: "Sign in to your account.",
            lblEmail: "Enter your email address:",
            lblPassword: "Enter your password:",
            reLoginText: "The login time has expired, please reload the page and try again",
            phEmail: "Email Address",
            phPassword: "Password",
            btnCheck: "Checking...",
            btnLogin: "Login",
            btnForgotPass: "Forgot password?",
            validating: {
                wrongAuth: "Your login details are incorrect, please try again",
                errorEmail: "Please enter a valid email address",
                errorPassword: "The password must be between 8 and 40 characters long and contain upper and lower case letters, numbers, and special characters.",
                errorSimplePassword: "Please enter a valid password",
				userRespondent: "Attention! Users who currently have responder privileges are not allowed to log in!",
            }
        },
        forgotPassword: {
            title: "Forgot password",
            text: "Please enter your email address",
            process: "Email sending, please wait...",
            successMessage: "Your password has been reset and sent to your email.",
        },
        breadcrumbs: {
            home: "Home",
        },
        dashboard: {
			pieces: "piece(s)",
			persons: "person(s)",
			projects: "Projects",
			collectionModules: "Data collection modules",
			activities: {
				daily: "Daily user activity",
				weekly: "Weekly user activity",
				monthly: "Monthly user activity",
				custom: "User activity based on unique dates",
			},
			menuOptions: {
				moduleShow: "Show data",
				moduleSettings: "Open module setup",
			},
			projectData: {
				modules: "Modules",
				responsers: "Respondents",
				researchers: "Researchers",
				noImage: "No image uploaded.",
			},
			projectTable: {
				name: "Project name",
				status: "Project status",
				timeline: "Timeline",
			},
			gotoProjectData: "Go to project data",
			panelHeader: {
				clientNum: "Number of clients",
				moduleNum: "Number of modules",
				projectNum: "Number of projects",
				dataSizeNum: "Data size",
				daysLeftNum: "Days left",
				responserNum: "Number of respondents",
				researcherNum: "Number of researchers",
			},
			mediaBrowser: {
				filter: {
					mediaTypeText: "Media type...",
					responderText: "Responder...",
					dataDeleteText: "Remove selected files",
					filterDeleteText: "Clear the set filters",
				},
				location: {
					title: "Location data of the recorded file",
					recordTime: "The time of recording: {rectime}",
				},
			},
			surveyData: {
				table: {
					userName: "Responder's name",
					saveDate: "Save date",
					startDate: "Start date",
					finishDate: "Finish date",
					questionName: "Question name",
				},
				filter: {
					range: "Range",
					deleteText: "Remove selected answers",
				},
				responsers: "Respondents",
				questionCodes: "Question codes",
			},
			exportText: "The export process is underway. We will let you know when it is ready! In the meantime, feel free to continue working.",
        },
        headerMenu: {
            dashboard: "Dashboard",
            settings: "Settings",
            logout: "Logout"
        },
        sidebarMenu: {
            mainmenu: "Main Menu"
        },
        settings: {
            title: "Settings"
        },
        notifications: {
            btnAdd: "New notification",
            titles: {
                list: "Email notifications",
                edit: "Edit email notification",
            },
            descs: {
                list: "List of registration email notifications sent so far.",
                edit: "Edit the email notification for new registration requests using the form below.",
                 },
            table: {
                name: "Name of the notification",
                type: "Type of the notification",
                updated: "Updated",
                hasUsers: "Existing respondents",
                newUsers: "New respondents",
                surveyName: "Name of the registration form",
                sendElemNum: "Number of the sended questions",
                answeredElemNum: "Number of answered questions",
            },
            form: {
                lbName: "Notification name",
                lbLang: "Choose the language",
                lbType: "Choose the type of the notification",
                lbSurvey: "Choose the registration form",
                lbAddresses: "Add the email addresses",
                lbEmailTemp: "Choose the email template",
                phName: "Name the notification",
                phType: "Select respondent to be notified",
                phSurvey: "Select the registration form",
                phAddresses: "List email addresses separated by ENTER.",
            },
            types: {
                hasuser: "Existing respondents",
                newuser: "New respondents",
            },
            validating: {
                name: "Please add a name for the notification! The number of characters must be between 5 and 100.",
                type: "Please select between new or existing respondents to be notified!",
                regsurvey: "Please select a registration form!",
            },
            messages: {
                saveSuccess: "Notification saved successfully.",
            }
        },
        clients: {
            titles: {
                list: "Clients",
                edit: "Editing client data"
            },
            descs: {
                list: "Clients added to the system.",
                edit: "You can edit your client details using the form below."
            },
            form: {
                lbName: "Client's name",
                lbCode: "Client's unique code",
                lbEmail: "Client's email address",
				lbLang: "Client's default language",
                lbPhone: "Client's phone number",
                lbAddress: "Client's address",
                lbConName: "Contact's name",
                lbConEmail: "Contact's email address",
                lbConPhone: "Contact's phone number",
                lbConPos: "Contact's position",
                lbRegister: "Client registration form",
                lbActive: "Client activation status",
                phName: "Enter the name of client",
                phCode: "Enter an unique code of client",
                phEmail: "Enter the email address of client",
                phPhone: "Enter the phone number of client",
				phLang: "Select a language",
				phMoreLang: "Choose at least one language from the options",
                phAddress: "Enter the address of client",
                phConName: "Enter the name of contact",
                phConEmail: "Enter the email address of contact",
                phConPhone: "Enter the phone number of contact",
                phConPos: "Enter the position of contact",
                phRegister: "Select a registration form (optional)",
                btnGenerate: "Generate to client code",
                btnGenerating: "Generation in progress..."
            },
            modals: {
                deleteDesc: "Are you sure you want to delete the selected client? If you do, the users associated with that client will not be able to log in, start, or participate in a project.", // removed can and added oxford comma
                deleteTitle: "Delete the selected client",
                warningDesc: "You have generated a new code for the client. If you leave the page now, the changes will not be saved. If you want to save the changes, close this window and press the Update button.",
                warningTitle: "Are you sure leave the page?",
                generateTitle: "Generate new client's code",
                generateDesc: "Are you sure you want to generate new client's code? Changing the code may affect further processes.",
                statusTitle: "Change client status",
                statusOnDesc: "If you turn it back on, the client and its users will be able to log back in and the client's projects will be available again.",
                statusOffDesc: "If you turn it off, the users associated with that client will not be able to log in, start, or participate in a project.",
            },
            messages: {
                deleteSuccess: "The client has been successfully deleted",
                updateSuccess: "The client's details have been successfully updated.",
                updateStatusSuccess: "The client's status has been successfully updated",
            },
            validating: {
                name: "Enter the client name (required)",
                email: "Enter the client email address through which you can be reached",
                code: "Enter the unique identifier of the client - click on the Generate client code button"
            },
            clientName: "Client name",
            clientEmail: "Client email address",
            clientStatus: "Client's status",
            btnAddNewClient: "Add new client"
        },
        users: {
            addUser: "Add a new user",
            editUser: "Edit a user",
            userProfile: "Edit my profile",
            userForProject: 'Set additional properties for the "{pname}" project.',
            userForProjectSubTitle: "Provide as much information as you can to maximise your chances of being included in the sampling process.",
            userList: "Managing users",
            userSubTitle: "Fill in all the elements of the form and press the save button.",
			successSave: "The new user has been saved in the system.",
			successUpdate: "Successfully updated the user.",
			successDelete: "Successfully deleted the user.",
			wrongAuthDatas: "As we have not been able to clearly define your user rights, please log in again!",
            userListSubTitle: "The table below shows the users present in the system. You can edit/delete data according to your rights.",
            editFormNameTitle: "Name",
            editFormEmailTitle: "Email",
            editFormRoleTitle: "Role of the user",
            editFormRightTitle: "The user's access right",
            editFormClientTitle: "The user belongs to this client",
            editFormPasswordTitle: "Password",
            editFormRePasswordTitle: "Password again",
            errorNameTitle: "The name field is not be to empty",
            modalTitle: "Confirm delete user",
            modalText: "Are you sure you want to delete the selected user?",
            phRole: "Please select a role group",
            phClient: "Select a client",
            table: {
				from: "From",
                name: "Name",
                added: "Add researcher to project",
                registered: "Registered",
				lastlogin: "Last login",
                roles: "Role",
				client: "Client",
				rights: "Access rights",
                status: "Status",
				selectRole: "Select a role"
            },
            role: {
                res: "Researcher",
                user: "Responder",
                admin: "Administrator",
            },
            validating: {
                name: "Please enter your name! Possible number of characters: 5-100",
                email: "Please enter a real email address! Possible number of characters: 5-100",
                password: "Your password should contain lowercase and capital letter, numbers, and at least one special character. Password length: 8-40 characters. Both passwords must match!", // added oxford comma
                passwordsAreEmpties: "Both password fields are required!",
				noClient: "Client selection is mandatory!",
				noRight: "Selection of the right group is mandatory!",
				noRole: "Selecting a role is mandatory!",
            }
        },
		roles: {
			modals: {
				removeText: "Are you sure you want to delete the selected role?",
				removeTitle: "Confirmation of the deletion of a role",
			}
		},
        emails: {
            titles: {
                list: "Email templates",
                edit: "Edit email template",
                send: "Send email",
                show: "Show email template",
                create: "Create email template"
            },
            texts: {
                list: "The table below shows the email templates in the database that can be used for sending emails",
                edit: "Change what you want in the form below, then press the change button",
                send: "You can use the form below to send the template to a recipient for testing",
                show: "Below is the content of the email template",
                create: "Fill in all the elements of the form below, then press the save button"
            },
            table: {
                name: "Name of template",
                subject: "Subject of message",
            },
            showDatas: {
                name: "The name of template",
                subject: "The subject of template",
                content: "The content of template"
            },
            form: {
                labelEmail: "Please add an email address",
                labelName: "Please add the name of template",
                labelDelete: "Specify whether the template can be deleted or not",
                labelDefault: "Specify whether the template is the default or not",
                labelSubject: "Please add the subject of email",
                labelContent: "Please add the content of email",
                labelSendLang: "Select the language in which you want to send the template",
                labelSelectLang: "Choose the language you want to display the template in",
                phEmail: "Email address",
                phName: "The name...",
                phSubject: "The subject...",
                phContent: "The content..."
            },
            validating: {
                name: "The name of the template must be given, and must be at least 5 characters long",
                subject: "The subject of the email must be given, and must be at least 5 characters long",
                content: "The content of the email must be given, and must be at least 10 characters long",
            },
            modal: {
                title: "Confirm the deletion of a selected email template",
                text: "Are you sure you want to delete this template?"
            },
                btnCreateText: "Create new template",
                successDeleted: "Email template deleted successfully.",
                successCreated: "Email template created successfully.",
                successUpdated: "Email template updated successfully.",
                successSendEmail: "Email sent successfully.",
        },
        profile: {
            menuHeader: "Account",
            menuUpdates: "Updates",
            menuMessages: "Messages",
            menuTasks: "Tasks",
            menuComments: "Comments",
            menuProfile: "Profile",
            menuSettings: "Settings",
            menuLockAccount: "Lock Account",
            menuLogout: "Logout",
        },
        peditor: {
            titles: {
                list: "Project designer",
                create: "Create new project",
                edit: "Edit project",
                result: "Project results",
                logresult: "Project logs",
                sampling: "Sampling",
                addDefault: "Please add basic project information",
                addUsers: "Please assign users to the project",
                addModules: "Please add modules to the project",
                addTriggers: "Set triggers for this module",
                changeStatus: "Change project status",
                addResearcher: "Select researchers and assign roles from the table",
                addRespondent: "Add a new respondent to the project",
                flipTitleError: "This module is not available",
                flipTextOk: "Module set up successfully. Add triggers for fine-tuning.",
                flipTextFullOk: "Module set up successfully. No further action needed.",
                flipTextError: "This module is not configured. Click the blue icon to configure it.",
                exportTitle: "Exported files",
                modifyTrixContent: "Edit the project's HTML content",
				modifyInfoCardContent: "Edit the project's info cards",
				removeInfoCardContent: "Delete project info cards",
                addModuleSpecificSettings: "Enter settings specific to this module",
            },
			menu: {
				logText: "Show logs",
				diagText: "Show diagnostics",
				removeText: "Remove the project",
				resultText: "Show results",
			},
			filter: {
				elem1Text: "Show those under preparation",
				elem2Text: "Show those under active data collection",
				elem3Text: "Show those under data processing",
				elem4Text: "Show archived",
				elem5Text: "Show removed",
			},
            texts: {
                list: "Projects with a white background are yours; light brown indicates projects you’ve been invited to.",
                edit: "Edit your project using the form below.",
                create: "Use the settings below to customize your project.",
                status: "Project status:",
                result: "View and download the project results below.",
                logresult: "Project logs by user are shown below.",
                actives: "Active modules",
                passives: "Inactive modules",
                addAName: "Enter a name...",
                changeStatusText: "Select a new status!",
                addFilterText: "Enter a filter condition",
                sampling: "Use the visual editor to build your team.",
                addUserText: "This table lists the users added to the project.",
                addedUserNum: "Sample: {count} respondents",
                creatorDate: "Project created on {created} by {name}",
                lastModified: "Last modified on {modified} by {name}",
                addModuleText: "Click the green plus icon on the right to add modules.",
                addTriggerText: "Use the panel below to configure triggers for this module.",
                addedResearchers: "{count} researcher(s) invited",
                addResearcherText: "Select one or more researchers below, then assign their roles in the project.",
                responserNumText: "Max number of respondents that can be invited:",
                contributorNumText: "Max number of researchers that can be invited:",
                dataCollection: "Data collection",
                setViewPageText: "Switch to a different view",
                myProjectText: "My projects",
                activeProjectText: "Active projects",
                passiveProjectText: "Inactive projects",
                addTriggerShowText: "The calendar below shows all configured triggers.",
                addNewModuleText: "Add new module",
                deleteModuleText: "Delete module",
                surveyModuleText: "Switch to survey module",
                locationModuleText: "Switch to location module",
                wrongAddedResearcher: "You must select a privilege level for the user!",
                smsModuleText: "Switch to SMS module",
                callModuleText: "Switch to call module",
                audioModuleText: "Switch to audio module",
                photoModuleText: "Switch to photo module",
                videoModuleText: "Switch to video module",
                eventsModuleText: "Switch to events module",
                appUsageModuleText: "Switch to app usage module",
                editModuleText: "Click to configure module",
                errorModuleText: "There’s a problem with this module’s settings. <strong>Please check!</strong>",
                timeTriggerText: "<strong>Number of time triggers: </strong>",
                locationTriggerText: "Number of location triggers:",
                triggerNumberText: "Triggers added to the module",
                defaultActiveText: "If active...",
                defaultTriggerText: "Then do this:",
                selectedActiveText: "If this is active:",
                enableModuleEditText: "All project modules are now available for editing again.",
                addTriggerToModuleText: "Add trigger to module",
                selectModuleToTriggerText: "Select a module:",
                expiredprojectInfoText: "This project has expired. Incoming data is no longer monitored.",
                lastUploadDate: "Respondent’s last upload date:",
                noUploadData: "Warning! No data has been received from this respondent yet.",
                cycleStartAndEnd: "Measurement cycle start and end:",
                loadedRespondentsNum: "Loaded respondents: {count}",
                exportText: "Below is a table showing exported files. To download an existing export, click below. To create a new one, press the button.",
                exportProcess: "Exporting may take time depending on the number of records.",
                noLocationData: "No location data available for this project. Heat map is unavailable.",
                wrongImageUpload: "Image must be under 1MB and in jpg, jpeg, png, or svg format.",
				wrongIconImageUpload: "Image must be under 1MB and in png, or svg format.",
                successRemoveImage: "Image deleted successfully.",
				successRemoveInfoCard: "The info card has been successfully deleted.",
                openImageLinkText: "Open image",
                closeImageLinkText: "Close image",
                removeImageLinkText: "Delete image",
                listForDashboardText: "Below are your linked projects",
                successRemoveModuleText: "Module deleted successfully.",
                warningPlatformModuleText: "This platform includes disabled modules marked in grey. Please remove them from your project.",
                viewModuleSelectorBlockText: "To show the module selector, enter a project name, language(s), and target platform.",
                addModuleSpecificSettingsText: "Set parameters specific to this module.",
                errorRemoveLogicalTriggerText: "Warning! This trigger is linked to another one and cannot be deleted.",
            },
			views: {
				role: "Role view",
				calendar: "Calendar view",
				timeLine: "Timeline view",
			},
            form: {
                labelAcro: "Project acronym",
                labelName: "Project name",
                labelDesc: "Internal project description. Remaining characters: {count}",
                labelLang: "Available languages for this project",
                labelAppDesc: "Project description shown in the mobile app",
                labelEndDate: "Project end date",
                labelStartDate: "Project start date",
                labelRegSurveys: "Registration or panel survey for this project",
                labelUploadProjectImage: "Upload a project image",
                phAcro: "Enter the project acronym (min. 2 characters)",
                phName: "Enter the project name (min. 5 characters)",
                phDesc: "Enter a description for the project",
                phSurv: "Select a survey...",
                phPlat: "Select at least one platform",
                phImageUpload: "Upload an image for the project",
                btnAddToProject: "Add to project",
                phModuleImageUpload: "Upload icon or image for the module",
            },
			infoCards: {
				addNewCard: "Add new info card",
				phIcon: "Select info card icon (SVG or PNG file)",
				phTitle: "Enter info card name here",
				labelIcon: "Info card icon",
				labelTitle: "Info card name",
				labelSDate: "Info card start date (optional)",
				labelEDate: "Info card end date (optional)",
				labelSelectType: "Select info card size",
				tableTitle: "The name of the info card",
				tableStartDate: "Info card start date",
				tableEndDate: "Info card end date",
				tableLanguage: "The language of the info card",
				reallyRemoveInfoCard: "Are you sure you want to delete the selected info card?",
			},
            modal: {
                title: "Confirm deletion of selected project",
                moduleTitle: "Confirm deletion of selected module",
                surveyTitle: "Add survey to project",
                uploadTitle: "Upload CSV with new users",
                smsTitle: "Configure SMS module",
                callTitle: "Configure call module",
                audioTitle: "Configure audio module",
                photoTitle: "Configure photo module",
                videoTitle: "Configure video module",
                eventTitle: "Configure events module",
                appUsageTitle: "Configure app usage module",
                locationTitle: "Add location settings to project",
                activateTitle: "Activate selected project",
                dailyInfoTitle: "View daily data",
                inactivateTitle: "Deactivate selected project",
                imageModuleTitle: "View uploaded image",
                removeImageTitle: "Confirm image deletion",
                loadTriggerTitle: "Load trigger template",
                loadGoogleMapsTitle: "View locations on Google Maps",
                saveTriggerTitle: "Save trigger settings",
                deleteTriggerTitle: "Delete selected trigger template",
                removeMediaFilesTitle: "Confirm deletion of media files",
				removeSurveyAnswersTitle: "Confirm deletion of selected answers",
                deleteLogicalTriggerTitle: "Confirm deletion of logical links",
                deleteLogicalTriggerText: "Are you sure you want to delete the logical links between triggers?",
                removeMediaFilesConfirmText: "Yes, delete the selected media files!",
				removeSurveyAnswersConfirmText: "Yes, delete the selected answers!",
                removeMediaFilesAlertText: "Warning: This action is permanent. Selected files will be permanently removed from the system!",
				removeSurveyAnswersAlertText: "Please note that this deletion cannot be undone. The selected responses and their associated media files will be permanently deleted from the system!",
                removeMediaFilesText: "Please confirm deletion of the following files:",
				removeSurveyAnswersText: "Please confirm deletion of the following answers:",
                mathCaptchaText: "Solve the simple math problem below:",
                text: "Are you sure you want to delete this project?",
                urlPHText: "Page where the survey will be embedded (e.g., websitename.com)",
                moduleText: "Are you sure you want to delete this module from the project?",
                surveyText: "Select a survey from the dropdown below",
                surveyType: "Survey type:",
                surveyExpire: "Survey expiration:",
                surveyUsedNotif: "Survey can be completed via push notification",
                surveyEmbed: "Survey can be embedded on external websites",
                uploadText: "Select a CSV file:",
                uploadPHText: "Upload CSV...",
                uploadCancel: "No import — the CSV file contained no new data.",
                uploadCancelMaxResponsers: "Import canceled — the CSV has more respondents than allowed for this client.",
                uploadSuccess: "CSV uploaded and users imported successfully.",
                moduleAppText: "Module description shown in app:",
                moduleColorText: "Module color:",
                moduleShortText: "Short module description:",
                removeImageText: "Are you sure you want to delete this image?",
                moduleFontColorText: "Font color for module:",
                activateText: "Are you sure you want to activate this project?",
                inactivateText: "Are you sure you want to deactivate this project?",
                loadTriggerText: "Choose a trigger template from the list below.",
                saveTriggerText: "Enter a name for the trigger template:",
                deleteTriggerText: "Are you sure you want to delete the selected trigger?",
                deleteTriggerGroupText: "Are you sure you want to delete this trigger group?",
                deleteTriggerDefaultText: "Are you sure you want to delete the selected trigger?",
                tabAddNewRespondent: "Add new respondent",
                tabSelectRespondent: "Add existing respondent",
                addNewResponderName: "Enter full name of respondent",
                addNewResponderEmail: "Enter respondent's email address",
                phResponderName: "Enter name of new user",
                phResponderEmail: "Enter email of new user",
                phpResponderPass: "Create a password (optional)",
                phpResponderRePass: "Re-enter password",
                lbEmailAddress: "Choose an email address from the list",
                surveyModuleText: "Survey module name (max 15 characters)",
                confirmDeleteText: "Are you sure you want to remove this user from the project?",
                confirmImportText: "At least one user is linked to the project. Importing new users will delete the current ones.",
                locationModuleText: "Location module name (max 15 characters)",
                surveyModuleLabel: "Survey module name",
                smsModuleLabel: "SMS module name",
                audioModuleLabel: "Audio module name",
                photoModuleLabel: "Photo module name",
                videoModuleLabel: "Video module name",
                phoneModuleLabel: "Call module name",
                eventModuleLabel: "Event module name",
                appUsageModuleLabel: "App usage module name",
                locationModuleLabel: "Location module name",
                frequencyLabel: "Data collection frequency",
                freqRecordingLabel: "Data recording frequency",
                freqRecordingText: "Enter values like: 60 OR 10:00; 11:00; 12:00",
                canFilterExportText: "Filtered data can also be exported",
                gpsAccurary: "Set GPS accuracy",
                bitRateLabel: "Set bitrate:",
                sampleRateLabel: "Set sample rate:",
                recordTimeLabel: "Recording time:",
                photoSizeLabel: "Image size:",
                photoWidthHolder: "X dimension of image",
                photoHeightHolder: "Y dimension of image",
                photoQualityLabel: "Image quality:",
                photoOrientedLabel: "Image orientation:",
                videoQualityLabel: "Video quality:",
                canRecordSoundLabel: "Record audio?",
                locationRequiredLabel: "Is location data required for media files?",
            },
            results: {
                projectStartEndDates: "Project start date: {0}. Project end date: {1}",
                tabCheckDatas: "Check received data",
                tabDatasOnDiagram: "Data visualized on graphs",
                resultDate: "Selected date: {0}",
                exportDatas: "Export module data",
                resultDatas: "Daily data points submitted by respondent: {0}",
                resultModuleName: "Module name: {0}",
                resultResponderName: "Responder name: {0}",
                missingUploads: "Show respondents with no uploads this week:",
                tableUser: "Responder name",
                tableNrcId: "NRCID",
                tableRegister: "Registration date",
                tableEmailAddress: "Email address",
                tableProgress: "Overall progress",
                tableDataProgress: "Weekly data progress",
                textNoResult: "No results match the selected filter criteria.",
            },
            sampling: {
                blocks: {
                    nameVars: "Variables",
                    nameStat: "Statistic",
                    nameFilters: "Filter settings",
                    nameSampling: "Additional filters",
                    nameSelectedUsers: "Selected users",
                },
                codeeditor: {
                    optFilter: "Functions",
                    optLogic: "Logical operators",
                    lblCheck: "Check",
                    helps: {
                        txtIs: "The IS function is used to determine whether or not the value of a given variable is specified. EXAMPLE: 'age' IS NULL -> this means that we are interested in matches that do not specify their age. This can also be negated, EXAMPLE: 'age' IS NOT NULL -> this will list the users where the age data was entered.",
                        txtOr: "The purpose of the OR logical variable is to return a match if at least 2 variables match the condition. EXAMPLE: 'sex' = \"man\" OR 'age' < 30 -> this means that we want to find matches that are either male or under 30. A more complex EXAMPLE: ('sex' = \"man\" AND 'age' < 25) OR ('sex' = \"man\" AND 'age' BETWEEN(25,50)) -> this means we want matches who are male AND under 25, OR male and between 25 and 50.",
                        txtAnd: "The purpose of the AND logical variable is to return a match when at least 2 variables have both values that match the conditions. EXAMPLE: 'sex' = \"woman\" AND 'age' BETWEEN(18,30) -> this means that we want users who are female and between 18-30 years old.",
                        txtAny: "The ANY function is used when there are several possible correspondences for a given variable value. EXAMPLE: eyecolor = ANY(\"brown\",\"blue\",\"green\") -> this means that we want users whose eye color is brown, green or blue. ANOTHER EXAMPLE: eyecolor = NOT ANY(\"blue\",\"green\") -> this means we want users whose eye color is not blue or green.",
                        txtMax: "The MAX function is used when we need users who have set a certain value to the maximum. EXAMPLE: MAX(age) -> this means that we need users whose age is the highest.  The function will take the largest value, so for example if there are many 70 year olds in the database, then more, and if there is only one 70 year old, then only one will be listed.",
                        txtMin: "The MIN function is used when we need users who have set a certain value to the smallest. EXAMPLE: MIN(age) -> this means that we want users whose age is the smallest. The function will take the smallest value, so for example if there are many 20 year olds in the database, then more, if there is only one 20 year old, then only one will be listed.",
                        txtNot: "The NOT logical variable can usually be used before functions (except for the IS function) to negate something. EXAMPLE: email NOT CONTAIN(\"%gmail%\") -> this means that we want to know about users who are not registered with a gmail email address. More complex EXAMPLE: age NOT BETWEEN(18,30) AND sex NOT CONTAIN(\"wo%\") -> this means we want users who are NOT 18-30 years old AND NOT women.",
                        txtNull: "The NULL parameter is used in conjunction with the IS function, so see its description.",
                        txtLimit: "The LIMIT function is used when you want to limit the number of records to be queried. EXAMPLE: LIMIT 9, 100 -> this means that we want to display only 100 elements starting from the 10th element of the retrieved records.",
                        txtBetween: "The BETWEEN function is used for more complex queries, which can be used in conjunction with other functions. Its purpose is to express more concisely the limits within which we want to display results. EXAMPLE: age = BETWEEN(MIN(age) + 5, MAX(age) - 4) AND sex = \"WOMAN\" -> this means that we want to get hits for people whose age is 5 more than the minimum and 4 less than the maximum and women. To put it even more simply, EXAMPLE: age = BETWEEN(MIN(age) + 5, MAX(age) - 4) AND sex CONTAIN(\"WO%\")",
                        txtContain: "The CONTAIN function is used when we want to find matches that match a given string pattern. EXAMPLE: email CONTAIN(\"%tk.%\") -> this means that we are looking for users whose email address contains the expression \"tk.\".",
                    },
                    statuses: {
                        noCode: "Please provide the code.",
                        noSpace: "Your code has no spaces. Please edit your code.",
                        noResult: "No results found. Please modify your code.",
                        allRight: "The provided filter looks good.",
                        loadedCode: "Previously used filter has been successfully loaded.",
                        errors: {
                            errorNotVar: "The code contains a variable that is not present on the \"variables\" panel.",
                            errorNotOperand: "There is no mathematical symbol in your code.",
                            errorNotEqualVar: "The code contains a variable that is not available in your project.",
                            errorMissingParts: "The code has variables without a value and math symbols",
                            errorLogicOperands: "The code has a logical statement without proper coding.",
                            errorUseLimitFunc1: "The parameters of the LIMIT function should be separated by a comma.",
                            errorUseLimitFunc2: "Both parameters of the LIMIT function have to be an integer.",
                            errorWrongBrackets: "Problem with the brackets in your code. Please check your code again.",
                            errorFirstLimitFunc: "The LIMIT function has to be placed at the end of your code not at the beginning.",
                            errorWrongQuoteOnVar: "The code contains a variable without proper quoting.",
                            errorNotLastLimitFunc: "The LIMIT function has to be placed at the end of your code.",
                            errorWrongQuoteOnValue: "The code contains a value without proper quoting.",
                            errorWrongISFunctionUse: "The IS function was not used correctly in your code. Please check again.",
                            errorUseBetweenFuncParam: "The parameters of the BETWEEN function can only contain numbers or a MIN and MAX function.",
                            errorWrongFunctionOpenBracket: "The \"(\" sign is missing after the function.",
                        }
                    }
                },
                form: {
                    lblSeed: "Value of seed",
                    lblIDSeq: "IDs in sequance",
                    lblFirstLine1: "The selected respondents",
                    lblFirstLine2: "",
                    lblSecondLine1: "Exactly",
                    lblSecondLine2: "respondents",
                    lblThirdLine1: "From",
                    lblThirdLine2: "to",
                },
                modal: {
                    colFirst: "The question",
                    colSecond: "The property",
                },
                btnAddNewVar: "Add new variable",
                btnSaveSample: "Save sample",
                btnAddAllUsers: "Load all users",
                btnResetFilters: "Reset filters",
                btnRefreshSample: "Refresh sample",
            },
            modules: {
                surveyName: "Survey",
                surveyText: "Add a survey to project",
                locName: "Location",
                locText: "Add the location module",
                actName: "Activity",
                actText: "Add the activity module"
            },
			logTable: {
				type: "Type of log",
				desc: "Description of log",
				cycles: "Cycle times",
				created: "Created date of log"
			},
            usersTable: {
                titleName: "Name",
                titleEmail: "Email",
                titleRemove: "Remove"
            },
            surveyTable: {
                titleName: "Name",
                titleSurvey: "Select the survey"
            },
            triggerTable: {
                titleName: "The name of template",
                titleTrigger: "Select a trigger",
                titleModuleName: "Relevant module",
                titleOperationName: "Trigger operation",
            },
            validating: {
                name: "Project name is required and must be at least 5 characters long.",
                acronym: "Project acronym is required and must be at least 2 characters long.",
                endDate: "Please enter the project's end date.",
                endTime: "Please enter the project's end time.",
                startDate: "Please enter the project's start date.",
                startTime: "Please enter the project's start time.",
                desc: "Project description is required and must be at least 10 characters long.",
                nameResponder: "Responder name must be between 5 and 50 characters.",
            },
            messages: {
                newSuccess: "The new project has been successfully saved.",
                updateSuccess: "Successfully modified the project data."
            },
            triggers: {
                tabs: {
                    time: "Time settings",
                    location: "Location settings",
                    notification: "Notification settings",
                    logicalConnection: "Logical connections"
                },
				logicalBlocks: {
					time: "Time triggers",
					location: "Location triggers"
				},
				times: {
					set: "setting",
					withTimeSlot: "with time slot",
					withCustomTimeSlot: "with customized time slot",
					default: "Default settings",
					timeSlot: "Time slots",
					startTimeSlot: "Start time slot",
					endTimeSlot: "End time slot",
					color: "Color",
					dateStart: "Start date",
					timeStart: "Start time",
					dateEnd: "End date",
					timeEnd: "End time",
					loadTemp: "Load a template",
					saveTemp: "Save a template",
					removeRole: "Remove extisting role based on dates and times",
					addAliasName: "Enter the name of the trigger (optional)",
					savedTriggers: "Saved triggers",
					setNewTrigger: "Set a new trigger",
					addGracePeriod: "Add a grace period",
					saveGracePeriod: "Save grace period",
					noTriggerSetting: "No saved trigger role available",
				},
                nots: {
                    addPlace: "Please select a location...",
                    searchMap: "Select a location on the map",
                    zoomDefault: "Reset zoom",
                    blockTitle1: "Trigger selection",
                    blockTitle2: "Notification setup",
                    blockTitle3: "Saved notifications",
                    selectATrigger: "Select a trigger",
                    beforeNotification: "Notification before trigger starts",
                    inActionNotification: "Notification during trigger",
                    afterNotification: "Notification after trigger ends",
                    beforeTime: "How long before?",
                    inActionTime: "How many repetitions?",
                    afterTime: "How long after?",
                    pushNoti: "Mobile push notification",
                    emailNoti: "Email notification",
                    noNotiText: "No notifications recorded yet",
                    addNewTriggerBtn: "Set up a new trigger",
                    withEnMinute: "with {minute} minutes",
                    withTimes: "repeated {times} times",
                    setTimeTrigger: "Set time trigger",
                    setLocationTrigger: "Set location trigger",
                    setupNotification: "Notification configured",
                    form: {
                        titleUpTime: "Minimum active time for trigger",
                        titleAddPlace: "Add location",
                        titleShortDesc: "Short description",
                        titleDefaultSet: "Trigger configuration",
                        titleTriggerType: "Choose trigger type",
                        titleBetweenTime: "Minimum time between two triggers:",
                        titleDistanceFrom: "Distance from location",
                        titleLocationMove: "Location is movable",
                        titleSavedLocations: "Saved locations",
                        btnNewLocation: "Add new trigger",
                        textLocation: "Location trigger",
                        textNoLocation: "No locations available",
                        phOnlyNumber: "Only numbers allowed in this field",
                    }
                },
				logicTitle: "Triggers are between <strong>OR</strong> logical connect by default. On this interface, you can specify where and between which elements there should be <strong>AND</strong> logical connections. So a module can only appear or function if both the time <strong>AND</strong> location trigger conditions are met.<br><strong>Triggers marked in red have an AND logical connection!</strong>",
            },
            diags: {
                title: "Project diagnostics",
                desc: "View diagnostics for the selected project. The most recent data appears at the top of the table!",
                table: {
                    name: "Responder name",
                    diagType: "Diagnostic type",
                    diagDesc: "Diagnostic description",
                    created: "Date created"
                }
			},
			disabled: "You do not have any permissions for this project!",
            btnImport: "Import respondents",
			btnAddNewUser: "Add new respondent",
            btnSamplingOpen: "Open sampling editor",
            btnSamplingClose: "Close sampling editor",
			btnCreateNewExport: "Create a new CSV export file",
            createNewProjectText: "Create a new project",
            processNewProjectText: "Creation in progress...",
			hasUploadedImage: "Already uploaded image...",
        },
        survey: {
			tabs: {
				viewer: "View",
				designer: "Designer",
				settings: "Settings",
				flowchart: "Flowchart",
				variables: "Variables"
			},
            titles: {
                list: "Survey Editor",
                create: "Create a new survey",
                defaults: "Default data for new surveys",
                untitle: "Untitled question",
                undesc: "No description provided",
                unkey: "Enter a variable name, or one will be generated automatically",
                selectType: "Select a question type to add a new question",
                defaultSurveySettings: "Survey default settings"
            },
			surveyTypes: {
                traditional: "Traditional survey",
                traditionalDesc: "Create general surveys with full functionality.",
                register: "Registration survey",
                registerDesc: "Create registration forms to link users to projects.",
                panel: "Panel survey",
                panelDesc: "Create panel surveys to add new respondents to your database."
            },
            texts: {
                list: "Below are the currently active surveys.",
                create: "Use the editor below to build your questionnaire. You can reorder questions using drag & drop.",
                selector: "Select the type of survey you'd like to edit below.",
                autoTranslateText: "For multilingual surveys, questions and answers can be automatically translated. This is enabled by default, but you can turn it off if needed.",
                autoTranslateTitle: "Enable automatic translation",
                autoTranslateSuccess: "Text translated automatically.",
            },
            labels: {
                answerName: "Enter answer option",
                answerLabel: "Answer label",
                labelNextQuestion: "Next question to display",
				respondentsNumLabel: "respondent(s) selected",
				selectRespondentLabel: "Select at least one respondent...",
            },
            hints: {
                notRemove: "This item can't be deleted because it's linked to at least one project.",
                addNewQuestion: "Add a new question",
                successSettings: "Survey settings saved successfully. You can now use the designer tab.",
                warningDefaultCode: "Warning! Please change the question variable—it’s still set to default. Allowed characters: letters, numbers, and underscores.",
                warningDefaultSurveyName: "Warning! The survey name is required.",
                warningDefaultSurveyCode: "Warning! Please change the survey short name—it’s still set to default.",
                warningDefaultAddedCode: "Warning! Please rename and re-code this question—it was copied from an existing one.",
                warningSurveySpecialCodes: "Warning! Survey abbreviations may only contain letters and numbers.",
                warningWrongCode: "Please use no more than two underscores in the variable name!",
                warningChooseLang: "At least one language must be selected!",
                errorCodeExists: "This code already exists. Please choose a different one.",
                errorQuestionType: "The URL parameter does not match the survey type.",
            },
            modals: {
                title: "Confirm deletion of selected survey",
                text: "Are you sure you want to delete this survey?",
                warningTitle: "Warning! This action cannot be completed.",
                warningText: "This survey is currently part of an active project and cannot be deleted. To delete it, first remove it from the project.",
                changeTypeText: "Changing the question type will delete its settings and all existing responses. This cannot be undone.",
                changeTypeTitle: "Warning! You're about to change the question type.",
                removeAnswerTitle: "Confirm deletion of selected answer",
                removeQuestionTitle: "Confirm deletion of selected question",
                removeQuestionText: "Are you sure you want to delete this question?",
                removeAnswerText: "Are you sure you want to delete this answer?",
            },
			options: {
				title: "Options",
				required: "Required",
				multiple: "Multiple selection",
				randomize: "Randomize",
				other: "Other option",
				dontknow: "Don't know",
				notanswer: "Prefer not to answer",
			},
			questionTypes: {
				radio: "Radio",
				checkbox: "Multiple choice",
				longText: "Long text",
				shortText: "Short text",
				number: "Number",
				email: "Email",
				phoneNumber: "Phone number",
				date: "Date",
				time: "Time",
				dateTime: "Date & Time",
				audio: "Audio upload",
				video: "video upload",
				photo: "Photo upload",
			},
			settingMenus: {
				default: "Default settings",
				view: "View",
				import: "Import",
				export: "Export",
				chooseMenu: "Please choose a menu item",
			},
			fullTypes: {
				blockChoices: "Basics",
				blockRatings: "Ratings & rankings",
				blockBlocks: "Blocks",
				blockTexts: "Texts",
				blockDates: "Dates & Times",
				blockUploads: "Uploads",
				blockContacts: "Contact infos",
				radio: "Radio",
				checkbox: "Multiple choice",
				longText: "Long text",
				shortText: "Short text",
				number: "Number",
				email: "Email",
				phoneNumber: "Phone number",
                website: "Website",
				date: "Date",
				time: "Time",
				dateTime: "Date & Time",
                pictureChoice: "Picture choice",
                yesNo: "Yes / No",
                matrix: "Matrix",
                opinionScale: "Opinion scale",
                likertScale: "Likert-scale",
                ranking: "Ranking",
                rating: "Rating",
                textBlock: "Text block",
                pictureBlock: "Picture block",
                videoBlock: "Video block",
                soundBlock: "Sound blokk",
                fileUpload: "File upload",
                videoUpload: "Video upload",
                photoUpload: "Picture upload",
                soundUpload: "Sound upload",
			},
            types: {
                numInt: "Integer",
                numReal: "Decimal number",
                numLabel: "Select the type of number to be entered",
                labelName: "Label name",
                textLabel: "Enter the maximum character length",
                phoneLabel: "Select the country code for phone number validation",
                textWarning: "so maximum characters allowed: {count}",
				commentLabel: "Would you like to allow comments for this user?",
                textNoSettings: "There are no additional options for this question type.",
				recordTimeLabel: "Add the maximum recording time",
				recordTimeWarning: "so {count} second(s)",
            },
            settings: {
                main: {
                    phName: "Survey name (max. 100 characters)",
                    phAcro: "Survey acronym (max. 20 characters)",
                    phDesc: "Survey description (max. 255 characters)",
                    surveyName: "Enter the name of your survey",
                    surveyAcro: "Enter a short, unique name for your survey",
                    surveyDesc: "Enter a description for your survey",
                    surveyLang: "Select the languages you want to use for this survey",
                },
                validating: {
                    surveyName: "Please enter a survey name between 5 and 100 characters",
                    surveyAcro: "Please enter a unique short name (min. 3, max. 20 characters)",
                    surveyDesc: "Please enter a survey description between 10 and 255 characters",
                    codeAlreadyExists: "This code already exists in the database.",
                    codeExceptsChars: "The code contains invalid characters.",
                },
            },
            dropdown: {
                name: "Functions",
                add: "Add a new question",
                set: "Settings",
                del: "Delete"
            },
            answers: {
                text: 'Short text answer',
            },
            errors: {
                server: "Server-side error",
                wrongAddedCode: "You cannot add this question because the name and code have not been changed from the previous one.",
                wrongCopiedCode: "You cannot copy this question because the name and code have not been changed from the original.",
            },
            btnCopy: "Copy the Survey",
			allTypes: "All question types",
            defaultDesc: "Untitled description...",
            defaultTitle: "Untitled title...",
			questionValue: "Question value",
			btnAddNewSection: "Add new section",
            createNewSurveyText: "Create a new survey"
        },
		textcontents: {
			titles: {
				editName: "Editing text content",
				editDesc: "The form can be used to create new text content or modify existing content.",
				listName: "Text contents",
				listDesc: "Text content available in the system",
			},
			tableList: {
				title: "Content title",
				removeText: "Status of content deletion",
				removable: "Removable",
				notRemovable: "Cannot be deleted",
			},
			form: {
				lbName: "Content title",
				phName: "Enter the title of the content",
				lbDelete: "Content can be deleted",
				lbContent: "The content",
			},
			validating: {
				title: "The content name must consist of at least 4 and no more than 100 characters.",
				desc: "The text content must consist of at least 10 characters.",
				noContent: "Don't forget to fill in the other translations too!",
			},
			modal: {
				deleteText: "Are you sure you want to delete the selected text? This action cannot be undone!",
				deleteTitle: "Confirm deletion of text content",
			},
			btnAdd: "Add new text content",
			saveSuccess: "Text content saved successfully",
			removeSuccess: "The text content has been successfully deleted.",
		},
        articleeditor: {
            titleName: "Title of article",
            statusName: "Status of article",
            titles: {
                list: "Article editor",
                edit: "Edit an article",
            },
            descs: {
                list: "Below are the articles currently in the system.",
                edit: "Use the form below to edit the article content.",
                upload: "You can upload a new image for the article if you'd like.",
                phUpload: "Upload a PNG or SVG file to update the article image.",
            },
            messages: {
                errorEditor: "Both the question and the answer must be provided in English and Hungarian.",
                uploadSuccess: "Image uploaded successfully.",
                updateSuccess: "Article updated successfully.",
                updateStatusSuccess: "Article status changed successfully.",
            },
        },
        faqeditor: {
            titles: {
                add: "Add a New FAQ",
                list: "FAQ Editor",
                edit: "Edit a FAQ",
            },
            descs: {
                add: "Use the form below to add a new FAQ to the system.",
                list: "Below is the FAQ content added to the system so far.",
                edit: "Use the form below to edit the FAQ content."
            },
            form: {
                phId: "Enter the short identifier of the FAQ, such as: question-one",
                phTitle: "Enter your question (min 5 characters)",
                phDesc: "Enter your answer (min 10 characters)",
                labelId: "FAQ ID:",
                labelTitle: "The question:",
                labelDesc: "Answer for the question:",
                labelActive: "Set state the FAQ"
            },
            messages: {
                errorEditor: "The question and the answer must be given in English and Hungarian.",
                saveSuccess: "The save has been successfully implemented.",
                deleteSuccess: "The delete has been successfully implemented.",
                updateSuccess: "The update has been successfully implemented.",
                updateStatusSuccess: "The status has been successfully changed.",
            },
            modal: {
                title: "Confirm the deletion of a selected FAQ",
                text: "Are you sure you want to delete this FAQ?"
            },
            faqIdName: "FAQ ID",
            faqTitleName: "The question",
            faqActivated: "State of FAQ",
        },
        octres: {
            titleName: "Researcher's name",
            titles: {
                list: "Octopus researchers",
                edit: "Edit researcher",
                fileUp: "Upload a new picture for the researcher (optional).",
                fileAct: "Current picture"
            },
            descs: {
                list: "Below are the researchers working with Octopus.",
                edit: "Use the form below to edit researcher details."
            },
            form: {
                phpPos: "Enter the researcher's position (min. 5 characters)",
                phTitle: "Enter the researcher's name (min. 5 characters)",
                phUpload: "Upload a PNG or SVG file to update the researcher's photo",
                phDesc: "Enter a description of the researcher (min. 10 characters)",
                labelPos: "Researcher's position:",
                labelTitle: "Researcher's name:",
                labelDesc: "Researcher's description:"
            },
            messages: {
                errorEditor: "All information must be provided in both English and Hungarian.",
                uploadSuccess: "Image uploaded successfully.",
                updateSuccess: "Researcher information updated successfully."
            },
        },
        nlsubs: {
            title: "Newsletter subscribers",
			text: "Newsletter subscribers who signed up through the frontend site.",
			table: {
                email: "Email address",
                createdat: "Date of registration"
            }
        },
        ressubs: {
            title: "Researcher subscribers",
            text: "Researcher subscribers who signed up through the frontend site.",
            table: {
                fname: "First name",
                lname: "Last name",
                email: "Email address",
                phone: "Phone number",
                createdat: "Date of registration"
            }
        }
    },
    hu: {
        comingSoon: "Hamarosan...",
        goToTop: "A lap tetejére",
        appVersionTitle: "Verzió",
        btnOk: "OK",
        btnAccept: "Rendben",
        btnAdd: "Hozzáad",
        btnBack: "Vissza",
        btnCopy: "Másol",
        btnSave: "Mentés",
        btnSend: "Küldés",
        btnShow: "Megjelenítés",
        btnEdit: "Szerkesztés",
        btnView: "Megtekintés",
        btnAdded: "Hozzáadva",
        btnClose: "Bezár",
		btnRoles: "Szerepkörök",
        btnCreate: "Létrehozás",
        btnUpload: "Feltöltés",
        btnUpdate: "Módosítás",
        btnDelete: "Törlés",
        btnCancel: "Mégse",
        btnExport: "Adatok exportálása",
		btnMediaExport: "Médiafájlok exportálása",
		btnFilter: "Szűrés",
        btnRemove: "Töröl",
		btnSearch: "Keresés",
		btnDownload: "Letöltés",
        btnSaveSend: "Mentés és küldés",
        btnSettings: "Beállítások",
        btnExporting: "Exportálás",
        btnLeavePage: "Elhagyom az oldalt",
        btnXlsExport: "Excel export",
        btnPdfExport: "PDF export",
		btnSaveLogic: "Logika mentése",
		btnShowResults: "Eredmények",
		btnFilterCancel: "Szűrések törlése",
		btnShowLogResults: "Logok megtekintése",
		btnShowDiagResults: "Diagnosztikák megtekintése",
        btnNewPwdRequired: "Új jelszó igénylése",
        btnBackToTheLogin: "Vissza a bejelentkező oldalra",
		closeWindowText: "Ablak bezárása",
		aServiceIsNotWorking: "Sajnáljuk, de ez a szolgáltatás jelenleg nem működik.",
        btnBackToTheMainPage: "Vissza a főoldalra",
        validateAttentionText: "Figyelem! Az alábbi problémá(k)ba ütköztem:",
        validateErrorNameText: "A névben használjon szóközt, és legalább 5 karakter hosszú legyen.",
        validateNullNameText: "A név mező nem lehet üres",
        validateNullRoleText: "Kérjük válasszon egy felhasználói csoportot",
        validateErrorEmailText: "Kérjük valós email címet adjon meg",
        validateNullEmailText: "Kérjük adja meg az email címet",
        validateErrorPasswordText: "A jelszónak 8-40 karakter közt kell lennie, legyen benne kis- és nagybetű, illetve szám és speciális karakter.",
        validateNullPasswordText: "Kérjük adja meg a jelszavát",
        validateNotEqualPasswordsText: "A megadott jelszavak nem egyeznek",
        validateLoginWrongAccount: "Hibás email cím vagy jelszó",
        validateForgotPasswordWrongText: "Ehhez az email címhez nem tartozik felhasználó.",
        defaults: {
			all: "Mindegyik",
			days: "nap",
			exit: "Kilépés",
			bytes: "byte",
			enter: "Belépés",
			best: "Legjobb",
			items: "elem",
			middle: "Közepes",
			low: "Alacsony",
			email: "Email cím",
			daily: "Napi",
			weekly: "Heti",
			monthly: "Havi",
			noResult: "A megadott feltételek szerint nincs találat.",
			landscape: "Fekvő nézet",
			portrait: "Álló nézet",
			content: "Tartalom",
			everyone: "Mindenki",
			anything: "bármennyi",
			initMaps: "Inicializálom a térképet, kérjük várjon...",
            initializing: "Inicializálás, kérjük várjon...",
            addAllFields: "Kérjük, töltsön ki minden mezőt",
            confirm: "Megerősítés",
            loading: "Betöltés, kérjük várjon...",
			removed: "Törölve",
            uploading: "Feldolgozás alatt, kérjük várjon...",
			unlimited: "korlátlan",
			text403: "A kért oldal megtekintéséhez nincs jogosultsága.",
			title403: "Jogosultsági hiba",
			text404: "A keresett oldal nem található.",
			title404: "Hoppá, hiba történt!",
			text429: "A szerver túlterhelt a túl sok kérés miatt. Kérjük, várjon egy percet, majd próbálja újra.",
			title429: "Túl sok kérés",
			disabled: "Letiltva",
            required: "Kötelező",
			optional: "Opcionális",
			mandatory: "Kötelező",
			notRequired: "Nem kötelező",
			registerDate: "Regisztráció dátuma",
			details: "Részletek",
			message: "Üzenet",
			fileName: "A fájl neve",
			attention: "Figyelem!",
            operation: "Művelet",
			moreOptions: "További lehetőségek",
            updatedField: "Módosítás dátuma",
			addNumberHolder: "Adjon meg egy számot",
			uploadPHImageText: "Válasszon ki egy képfájlt (svg, jpg, png)",
			fromWebText: "Webről",
			fromMobileText: "Mobilról",
			createdBy: "Készítette: ",
			createdFile: "A fájl neve: ",
            footerText: "Társadalomtudományi Kutatóközpont",
            pleaseSelect: "Kérjük válasszon...",
			serverError: "Szerver oldali hiba",
			latitude: "Szélesség",
			longitude: "Hosszúság",
			fieldSoText: "azaz",
			fieldMeterText: "méter",
			fieldHourText: "óra",
			fieldMinuteText: "perc",
			fieldSecondText: "másodperc",
			lastUpdaterText: "Módosította",
			fileNotFoundText: "A fájl nem található",
			lastModifiedText: "Utolsó módosítás",
			fieldMinutesPerText: "percenként",
			fieldElapsedTimeText: "Eltelt idő",
			fieldTimeIncreaseText: "Idő növelése",
			chooseTheOptions: "Válasszon a lehetőségek közül",
			activedModuleText: "Aktívált modul:",
			clickMeToEditText: "Kattintson ide a szerkesztéshez!",
			infoCardEditText: "Kattintson ide az infókártyák szerkesztéséhez!",
			gotoTheMainPage: "Vissza a főoldalra",
            wrongFileFormat: "Nem megfelelő fájl formátum!",
			wrongScreenSize: "A rendszer használhatához ajánlott felbontás: HD (1920x1080px)",
			failUpdate: "Kérjük ellenőrizze, hogy megadott-e minden kötelező adatot!",
			selectAnOption: "Válasszon egy lehetőséget",
			defaultUploadPicText: "A feltöltött kép",
			successImageUpload: "A kép feltöltése sikeresen megtörtént.",
            successSaveProcess: "Sikeres mentés.",
			successCreateProcess: "Sikeres létrehozás.",
			successUpdateProcess: "Sikeres módosítás.",
			successDeleteProcess: "Sikeres törlés.",
			successDraggedProcess: "Sikeres mozgatás.",
			downloadStartProcessText: "A letöltés elindult, kérjük várjon...",
			filteredResultNumberText: "A szűrés alapján a találatok száma:",
			errorMultipleSelectNotNull: "A legördülő mezőnek legalább egy elemet tartalmaznia kell!",
			cannotLogoutFromNewSurvey: "Figyelem! Amíg egy új kérdőív alapadatait szerkeszti, nem hagyhatja el a rendszert!",
			cannotLogoutFromNewProject: "Figyelem! Amíg egy új projekt alapadatainak szerkesztésekor nem történik mentés, nem hagyhatja el a rendszert!",
			filters: {
				elem: "elem",
				elements: "elem",
				mediaTypes: "Válasszon egy média típust",
				filterText: "Adjon meg egy szűrőfeltételt...",
				loadedNums: "Felhasználók száma: ",
				loadedResps: "Válaszadók száma: ",
				elemPerPage: "elem / oldal",
				removeFilterText: "Biztosan törölni szeretné a beállított szűrőket?",
				removeFilterTitle: "Beállított szűrők törlésének megerősítése",
			}
        },
        days: {
            monday: "Hétfő",
            tuesday: "Kedd",
            wednesday: "Szerda",
            thrusday: "Csütörtök",
            friday: "Péntek",
            saturday: "Szombat",
            sunday: "Vasárnap"
        },
        statuses: {
            active: "Aktív",
            deactive: "Nem aktív"
        },
        regVerifier: {
            name: "Regisztrációs kód ellenőrzése",
            process: "Ellenőrzés, kérjük várjon...",
            successMessage: "A regisztrációját sikeresen megerősítettük!"
        },
        usersTable: {
            titleName: "Név",
            titleEmail: "Email",
            titleAddTo: "A projekthez adom",
            titleRegTo: "Rergisztrációs email kiküldése"
        },
        login: {
            title: "Bejelentkezés",
            text: "Adja meg az alábbi adatokat a bejelentkezéshez",
            lblEmail: "Adja meg az email címét:",
            lblPassword: "Adja meg a jelszavaát:",
            reLoginText: "Lejárt a bejelentkezésre szánt idő, ezért kérjük jelentkezzen be újból a fiókjába az email cím és jelszó használatával",
            phEmail: "Email cím",
            phPassword: "Jelszó",
            btnCheck: "Ellenőrzés...",
            btnLogin: "Bejelentkezés",
            btnForgotPass: "Elfelejtettem a jelszavam",
            validating: {
                wrongAuth: "Hibás bejelentkezési adatok. Kérjük, próbálja meg újra!",
                errorEmail: "Valós email címet adjon meg.",
                errorPassword: "A jelszónak 8-40 karakter közt kell lennie, legyen benne kis- és nagybetű, illetve szám és speciális karakter.",
                errorSimplePassword: "Kérjük, érvényes jelszót adjon meg!",
				userRespondent: "Figyelem! Jelenleg válaszadói jogosultsággal rendelkező userek nem léphetnek be a rendszerbe!",
            }
        },
        forgotPassword: {
            title: "Elfelejtett jelszó",
            text: "Adja meg az email címet, az új jelszó elküldéséhez.",
            process: "Email küldése, kérjük várjon...",
            successMessage: "Sikeresen frissítettük a jelszavát, amelyet e-mailben kiküldtünk."
        },
        breadcrumbs: {
            home: "Főoldal",
        },
        dashboard: {
			pieces: "db",
			persons: "fő",
			projects: "Projektek",
			collectionModules: "Adatgyűjtő modulok",
			activities: {
				daily: "Napi felhasználói aktivitás",
				weekly: "Heti felhasználói aktivitás",
				monthly: "Havi felhasználói aktivitás",
				custom: "Egyedi időpontok alapján a felhasználói aktivitás",
			},
			menuOptions: {
				moduleShow: "Adatok mutatása",
				moduleSettings: "Modulbeállítás megnyitása",
			},
			projectData: {
				modules: "Modulok",
				responsers: "Válaszadók",
				researchers: "Kutatók",
				noImage: "Nincs kép feltöltve.",
			},
			projectTable: {
				name: "Projekt neve",
				status: "Projekt státusza",
				timeline: "Időtartam",
			},
			gotoProjectData: "Ugrás a projekt adatokhoz",
			panelHeader: {
				clientNum: "Ügyfelek száma",
				moduleNum: "Modulok száma",
				projectNum: "Projektek száma",
				dataSizeNum: "Adatméret",
				daysLeftNum: "Hátralévő napok",
				responserNum: "Válaszadók száma",
				researcherNum: "Kutatók száma",
			},
			mediaBrowser: {
				filter: {
					mediaTypeText: "Médiatípus...",
					responderText: "Válaszadó...",
					dataDeleteText: "A kijelölt fájlok törlése",
					filterDeleteText: "A beállított szűrők törlése",
				},
				location: {
					title: "A rögzített fájl lokációs adatai",
					recordTime: "A rögzítés ideje: {rectime}",
				},
			},
			surveyData: {
				table: {
					userName: "Válaszadó neve",
					saveDate: "Mentés ideje",
					startDate: "Kezdés ideje",
					finishDate: "Befejezés ideje",
					questionName: "Kérdés neve",
				},
				filter: {
					range: "Intervallum",
					deleteText: "Kijelölt válaszok törlése",
				},
				responsers: "Válaszadók",
				questionCodes: "Kérdéskódok",
			},
			exportText: "Az export folyamat elindult. Ha elkészült, értesítést küldünk. Addig folytathatja a munkát.",
        },
        headerMenu: {
            dashboard: "Vezérlőpult",
            settings: "Beállítások",
            logout: "Kijelentkezés"
        },
        sidebarMenu: {
            mainmenu: "Főmenü"
        },
        settings: {
            title: "Beállítások"
        },
        notifications: {
            btnAdd: "Új értesítés",
            titles: {
                list: "Email értesítések",
                edit: "Email értesítés szerkesztése",
            },
            descs: {
                list: "Korábban kilüldött regisztrációs email értesítők",
                edit: "Itt szerkeszthető az email szövege, amellyel értesíthetők a felhasználók az új regisztrációs igényről.",
            },
            table: {
                name: "Értesítés neve",
                type: "Értesítés típusa",
                updated: "Módosítva",
                hasUsers: "Meglévő felhasználók",
                newUsers: "Új felhasználók",
                surveyName: "Regisztrációs kérdőív neve",
                sendElemNum: "Kiküldött kérések száma",
                answeredElemNum: "Megválaszolt kérések száma",
            },
            form: {
                lbName: "Az értesítés neve",
                lbLang: "Válassza ki a nyelvet",
                lbType: "Válassza ki az értesítés típusát",
                lbSurvey: "Válassza ki a regisztrációs kérdőívet",
                lbAddresses: "Adja meg az email címeket",
                lbEmailTemp: "Válassza ki az email sablont",
                phName: "Adja meg az értesítés nevét",
                phType: "Válassza ki, hogy az értesítés mely felhasználóknak kerüljön kiküldésre.",
                phSurvey: "Válassza ki a regisztrációs kérdőívet",
                phAddresses: "Adja meg az email címeket ENTER-rel elválasztva.",
            },
            types: {
                hasuser: "Meglévő felhasználók",
                newuser: "Új felhasználók",
            },
            validating: {
                name: "Kérjük adja meg az értesítés nevét! A lehetséges karakterek száma: 5-100",
                type: "Kérjük adja meg, hogy új vagy már meglévő felhasználóknak szeretne értesítést küldeni?",
                regsurvey: "Kérjük válasszon egy regisztrációs kérdőívet!",
            },
            messages: {
                saveSuccess: "Az értesítés mentése sikeresen megtörtént.",
            }
        },
        clients: {
            titles: {
                list: "Ügyfelek",
                edit: "Ügyfél adatainak szerkesztése"
            },
            descs: {
                list: "A rendszerben lévő ügyfelek.",
                edit: "Az alábbi űrlap segítségével szerkesztheti az ügyfél adatait. A *-gal megjelölt mezők kitöltése kötelező."
            },
            form: {
                lbName: "Az ügyfél neve (*)",
                lbCode: "Az ügyfél egyedi azonosítója (*)",
                lbEmail: "Az ügyfél email címe (*)",
				lbLang: "Az ügyfél által használt alapértelmezett nyelv",
                lbPhone: "Az ügyfél telefonszáma",
                lbAddress: "Az ügyfél címe",
                lbConName: "A kapcsolattartó neve",
                lbConEmail: "A kapcsolattartó email címe",
                lbConPhone: "A kapcsolattartó telefonszáma",
                lbConPos: "A kapcsolattartó pozíciója",
                lbRegister: "Az ügyfél regisztrációs kérdőíve",
                lbActive: "Ügyfél aktiválás státusza",
                phName: "Adja meg az ügyfél nevét",
                phCode: "Adja meg az ügyfél egyedi azonosítóját",
                phEmail: "Adja meg az ügyfél email címét",
				phLang: "Válasszon egy nyelvet az alábbiak közül",
				phMoreLang: "Válasszon legalább egy nyelvet a lehetőségek közül",
                phPhone: "Adja meg az ügyfél telefonszámát",
                phAddress: "Adja meg az ügyfél címét",
                phConName: "Adja meg a kapcsolattartó nevét",
                phConEmail: "Adja meg a kapcsolattartó email címét",
                phConPhone: "Adja meg a kapcsolattartó telefonszámát",
                phConPos: "Adja meg a kapcsolattartó pozícióját",
                phRegister: "Válasszon egy regisztrációs kérdőívet (nem kötelező)",
                btnGenerate: "Ügyfélkód generálása",
                btnGenerating: "Generálás folyamatban..."
            },
            modals: {
                deleteDesc: "Biztosan törölni szeretné a kiválasztott ügyfelet? Ha igen, akkor a hozzá tartozó felhasználók se belépni, se projektet indítani vagy egy projektben részt venni nem fognak tudni.",
                deleteTitle: "A kiválasztott ügyfél törlése",
                warningDesc: "Új kódot generált az ügyfél számára. Ha most elhagyja az oldalt, a módosítások nem kerülnek mentésre. Ha el szeretné menteni a módosításokat, zárja be ezt az ablakot, és nyomja meg a Módosítás gombot.",
                warningTitle: "Biztosan el akarja hagyni az oldalt?",
                generateTitle: "Új ügyfélkód generálása",
                generateDesc: "Biztosan új ügyfélkódot szeretne generálni ? A kód megváltoztatása befolyásolhatja a további folyamatokat.",
                statusTitle: "Ügyfél státuszának módosítása",
                statusOnDesc: "Ha újra bekapcsolja, az ügyfél és felhasználói újra be tudnak jelentkezni, és az ügyfél projektjei ismét elérhetővé válnak",
                statusOffDesc: "Ha kikapcsolja, akkor az ügyfélhez tartozó felhasználók se belépni, se projektet indítani vagy egy projektben részt venni nem fognak tudni.",
            },
            messages: {
                deleteSuccess: "Az ügyfél törlése sikeresen megtörtént.",
                updateSuccess: "Az ügyfél adatainak módosítása sikeresen megtörtént.",
                updateStatusSuccess: "Az ügyfél státuszának módosítása sikeresen megtörtént.",
            },
            validating: {
                name: "Adja meg az ügyfél nevét (kötelező adat)",
                email: "Adja meg az ügyfél email címét, amin keresztül elérhető",
                code: "Adja meg az ügyfél egyedi azonosítóját - kattintson az ügyfélkód generálása gombra"
            },
            clientName: "Ügyfél neve",
            clientEmail: "Ügyfél email címe",
            clientStatus: "Ügyfél státusza",
            btnAddNewClient: "Új ügyfél hozzáadása"
        },
        users: {
            addUser: "Új felhasználó hozzáadása",
            editUser: "Felhasználó szerkesztése",
            userProfile: "Felhasználói profil szerkesztése",
            userForProject: "További tulajdonságok megadása a(z) {pname} nevű projekt számára.",
            userList: "Felhasználók kezelése",
            userSubTitle: "Töltse ki az űrlap összes elemét, majd nyomja meg a mentés gombot.",
			successSave: "Az új felhasználó rögzítve lett a rendszerben.",
			successUpdate: "A felhasználó adatai sikeresen módosultak.",
			successDelete: "A felhasználó sikeresen törölve lett a rendszerből.",
			wrongAuthDatas: "Mivel nem sikerült egyértelműen meghatározni a felhasználói jogait, ezért kérjük lépjen be újra a rendszerbe!",
            userListSubTitle: "A rendszerben jelen lévő felhasználók. Jogosultságának megfelelően tudja az adatokat szerkeszteni/törölni.",
            userForProjectSubTitle: "Adjon meg annyi adatot, amennyit csak tud, hogy a mintavételezési eljárásban minél nagyobb esélyekkel szerepelj.",
            editFormAgeTitle: "Életkor",
            editFormOptional: "Opcionális",
            editFormHomeTitle: "Lakhely",
            editFormNameTitle: "Név",
            editFormRightTitle: "A felhasználó jogosultsága",
			editFormRoleTitle: "A felhasználó szerepköre",
            editFormGenderTitle: "Nem",
            editFormClientTitle: "A felhasználó ehhez az ügyfélhez tartozik",
            editFormNationalityTitle: "Állampolgárság",
            editFormEmailTitle: "Email",
            editFormPasswordTitle: "Jelszó",
            editFormRePasswordTitle: "Jelszó újra",
			errorNameTitle: "A név mező nem lehet üres",
            modalTitle: "Kiválasztott felhasználó törlésének megerősítése",
            modalText: "Biztosan törölni szeretné a kiválasztott felhasználót?",
            phRights: "Kérjük válasszon egy felhasználói csoportot",
			phRole: "Kérjük válassz egy szerepkört",
            phClient: "Válasszon egy ügyfelet",
            phGender: "Adja meg a nemed (opcionális)",
            table: {
				from: "Honnan",
                name: "Név",
                added: "Kutató hozzáadása a projekthez",
                registered: "Regisztráció",
				lastlogin: "Utolsó belépés",
				roles: "Szerepkör",
				client: "Ügyfél",
                rights: "Jogosultság",
                status: "Státusz",
				selectRole: "Szerepkör kiválasztása"
            },
            role: {
                res: "Kutató",
                user: "Válaszadó",
                admin: "Adminisztrátor",
            },
            validating: {
                name: "Kérjük adja meg a nevét! Lehetséges karakterek száma: 5-100",
                email: "Kérjük adjon meg egy valós email címet! Lehetséges karakterek száma: 5-100",
                password: "A jelszóban legyen legyen kis- egy nagybetű, szám és legalább egy speciális karakter. A jelszó hossza: 8-40 karakter. Mindkét jelszónak egyeznie kell!",
				passwordsAreEmpties: "Mindkét jelszó mező kitöltése kötelező!",
				noClient: "Az ügyfél kiválasztása kötelező",
				noRight: "A jogosultsági csoport kiválasztása kötelező",
				noRole: "Egy szerepkör kiválasztása kötelező"
            }
        },
		roles: {
			modals: {
				removeText: "Biztosan törölni szeretné a kiválasztott szerepkört?",
				removeTitle: "Szerepkör törlésének megerősítése",
			}
		},
        emails: {
            titles: {
                list: "Email sablonok",
                edit: "Email sablon szerkesztése",
                send: "Email küldése",
                show: "Email sablon megjelenítése",
                create: "Email sablonok létrehozása"
            },
            texts: {
                list: "Az alábbi táblázatban láthatóak az adatbázisban szereplő email sablonok, amiket levélküldéshez tudunk használni",
                edit: "Végezze el a szükséges módosításokat, majd nyomja meg a módosítás gombot",
                send: "Az alábbi űrlap segítségével ki tudja küldeni egy címzettnek a sablont teszt céljából",
                show: "Az alábbiakban látható az email sablon tartalma",
                create: "Töltse ki az alábbi űrlap minden elemét, majd nyomja meg a mentés gombot"
            },
            table: {
                name: "A template neve",
                subject: "Az üzenet tárgya",
            },
            showDatas: {
                name: "A sablon neve",
                subject: "A sablon tárgya",
                content: "A sablon tartalma"
            },
            form: {
                labelEmail: "Kérjük adjon meg egy email címet",
                labelName: "Adja meg a sablon nevét",
                labelDelete: "Adja meg, hogy a sablon törölhető-e vagy sem",
                labelDefault: "Adja meg, hogy a sablon alapértelmezett-e vagy sem",
                labelSubject: "Adja meg a levél tárgyát",
                labelContent: "Adja meg a levél tartalmát",
                labelSendLang: "Válassza ki, hogy melyik nyelven szeretné elküldeni a sablont",
                labelSelectLang: "Válassza ki, hogy melyik nyelven szeretné megjeleníteni a sablont",
                phEmail: "Email cím",
                phName: "A sablon neve",
                phSubject: "A levél tárgya",
                phContent: "A levél tartalma..."
            },
            validating: {
                name: "A sablon nevét kötelező megadni és legalább 5 karakterből kell állnia.",
                subject: "A levél tárgyát kötelező megadni, és legalább 5 karakterből kell állnia.",
                content: "A levél tartalmát kötelező megadni, és legalább 10 karakterből kell állnia.",
            },
            modal: {
                title: "A kiválasztott email sablon törlésének megerősítése",
                text: "Biztosan törölni szeretné ezt a sablont?"
            },
            btnCreateText: "Új email sablon létrehozása",
            successDeleted: "Sikeresen töröltem az email sablont.",
            successCreated: "Sikeresen létrehoztam az email sablont.",
            successUpdated: "Sikeresen módosítottam az email sablont.",
            successSendEmail: "Az email sikeresen elküldve."
        },
        profile: {
            menuHeader: "Fiók",
            menuUpdates: "Frissítések",
            menuMessages: "Üzenetek",
            menuTasks: "Feladatok",
            menuComments: "Megjegyzések",
            menuProfile: "Profil",
            menuSettings: "Beállítások",
            menuLockAccount: "Account felfüggesztése",
            menuLogout: "Kijelentkezés",
        },
        peditor: {
            titles: {
                list: "Projekttervező",
                create: "Új projekt létrehozása",
                edit: "Projekt szerkesztése",
                result: "Egy projekt eredményei",
				logresult: "A projekthez tartozó logok",
                sampling: "Mintavételezés",
                addDefault: "Kérjük, adja meg az alapadatokat",
                addUsers: "Adjon felhasználókat a projekthez",
                addModules: "Adjon modulokat a projekthez",
                addTriggers: "Állítson be triggereket a modulhoz",
				changeStatus: "A projekt státuszának módosítása",
                addResearcher: "Válasszon kutatókat és szerepköröket a táblázatból",
				addRespondent: "Adjon hozzá a projekthez egy új válaszadót",
                flipTitleError: "A modul nincs beállítva",
                flipTextOk: "A modul beállítása sikeresen megtörtént. Adjon triggereket a modulhoz a további finomhangolások érdekében.",
                flipTextFullOk: "A modul beállítása sikeresen megtörtént. További teendője nincsen.",
                flipTextError: "A modul még nincs beállítva. A beállításhoz kattintson a kék ikonra.",
				exportTitle: "Eddig exportált fájlok",
				modifyTrixContent: "A projekt HTML tartalmának módosítása",
				modifyInfoCardContent: "A projekt infó kártyáinak szerkesztése",
				removeInfoCardContent: "A projekt infó kártyáinak törlése",
				addModuleSpecificSettings: "Add meg a modulspecifikus beállításokat",
            },
			menu: {
				logText: "Logok megtekintése",
				diagText: "Diagnosztikák megtekintése",
				removeText: "A projekt törlése",
				resultText: "Eredmények megtekintése",
			},
			filter: {
				elem1Text: "Előkészítés alatt",
				elem2Text: "Aktív adatgyűjtés",
				elem3Text: "Adatfeldolgozás",
				elem4Text: "Archivált",
				elem5Text: "Törölt",
			},
            texts: {
                list: "Felhasználói fiókjában az alábbi projektek érhetők el. A fehér háttérszín a saját projekteket, a barna háttérszín pedig az Önnel megosztott projekteket jelöli.",
                edit: "Az alábbi űrlap segítségével tudja módosítani a projektet",
                create: "Ezen az oldalon tudja szerkeszteni a projekt adatait.",
				status: "Projekt státusz: ",
                result: "Felhasználói fiókjában az alábbi projektek eredményei érhetők el.",
				logresult: "Felhasználói szintű logok",
                actives: "Aktív modulok",
                passives: "Passzív modulok",
				addAName: "Adjon meg egy nevet...",
				changeStatusText: "Kérjük válasszon egy új státuszt!",
				addFilterText: "Adja meg a keresési feltételt",
                sampling: "A vizuális szerkesztő segítségével állítsa össze a saját csapatát.",
                addUserText: "A táblázatban láthatja a hozzáadott felhasználókat",
                addedUserNum: "Minta: {count} válaszadó",
				creatorDate: "Létrehozás: {created}, {name}",
                lastModified: "Utolsó módosítás: {modified}, {name}",
                addModuleText: "A jobb oldalon lévő zöld ikon segítségével tud új modulokat hozzáadni a projekthez",
                addTriggerText: "Itt tudja beállítani a modulhoz tartozó triggereket",
                addedResearchers: "{count} meghívott kutató",
                addResearcherText: "A táblázatban található felhasználókat hozzá tudja rendelni a projekthez. A felhasználó kiválasztása után állítsa be a szerepkört.",
				responserNumText: "A projektbe meghívható válaszadók maximális száma:",
				contributorNumText: "A projektbe meghívható kutatók maximális száma:",
                dataCollection: "Adatgyűjtés",
                setViewPageText: "Váltás másik nézetre",
				myProjectText: "Projektjeim",
                activeProjectText: "Aktív projektek",
                passiveProjectText: "Passzív projektek",
                addTriggerShowText: "A naptárban láthatók a beállított idő-alapú triggerek. ",
                addNewModuleText: "Új modul hozzáadása",
                deleteModuleText: "A modul törlése",
                surveyModuleText: "A kérdőív modul beállítása",
                locationModuleText: "A lokációs modul beállítása",
				wrongAddedResearcher: "Válassza ki a felhasználó jogosultsági szintjét!",
				smsModuleText: "Az SMS modul beállítása",
				callModuleText: "A hívás modul beállítása",
				audioModuleText: "A hang modul beállítása",
				photoModuleText: "A kép modul beállítása",
				videoModuleText: "A videó modul beállítása",
				eventsModuleText: "Az esemény lekérdező modul beállítása",
				appUsageModuleText: "Az app használati modul beállítása",
				editModuleText: "Kattintson ide a modul beállításához",
                errorModuleText: "Probléma van a modul beállításaival, <strong>kérjük ellenőrizze!</strong>",
				timeTriggerText: "<strong>Időtriggerek száma: </strong>",
				locationTriggerText: "Lokációs triggerek száma: ",
                triggerNumberText: "A modulhoz hozzáadott triggerek száma",
                defaultActiveText: "Ha aktív...",
                defaultTriggerText: "Akkor az történjen, hogy ",
                selectedActiveText: "Ha aktív a(z) ",
				enableModuleEditText: "Mostantól újra lehet teljes körűen a projekthez tartozó modulokkal dolgozni.",
                addTriggerToModuleText: "Trigger hozzáadása a modulhoz",
                selectModuleToTriggerText: "Kiválasztandó modul: ",
				expiredprojectInfoText: "Ez már egy lejárt projekt, így a beérkező adatok már nem ellenőrizhetők.",
				lastUploadDate: "A válaszadó legutolsó feltöltésének pontos dátuma: ",
				noUploadData: "Figyelem! A válaszadótól még nem érkezett be adat!",
				criteriaDown: "Figyelem! Túl sok találat van erre a szűkítési feltételre. Kérjük, adjon hozzá további keresési feltételeket.",
				cycleStartAndEnd: "A mérési ciklus kezdete és vége: ",
				loadedRespondentsNum: "A betöltött válaszadók száma: {count} fő.",
				exportText: "A táblázatban látható, hogy eddig hány darab fájl került exportálásra. Ha nem akar új exportot, akkor a már meglévőket is letöltheti. Ha új exportot szeretne készíteni, akkor kattintson az alábbi gombra.",
				exportProcess: "Az export folyamat az adatbázisban tárolt rekordok számától függően hosszabb ideig is eltarthat!",
				exportBroadcastProcess: "Az export folyamatot elindítottuk, amint elkészült értesítést küldünk. Addig folytathatja a munkát.",
				noLocationData: "Jelenleg nincs az adatbázisban ehhez a projekthez rendelt lokációs adat, így a hőtérkép nem jeleníthető meg.",
				wrongImageUpload: "A kép maximális mérete: 1MB lehet. Engedélyezett formátumok: jpg, jpeg, png, svg.",
				wrongIconImageUpload: "A kép maximális mérete: 1MB lehet. Engedélyezett formátumok: png, svg.",
				successRemoveImage: "A kép törlése sikeresen megtörtént.",
				successRemoveInfoCard: "Az infó kártya törlése sikeresen megtörtént.",
				openImageLinkText: "A kép megtekintése",
				closeImageLinkText: "A kép bezárása",
				removeImageLinkText: "A kép törlése",
				listForDashboardText: "A felhasználói fiókban jelenleg elérhető projektek",
				successRemoveModuleText: "A modul törlése sikeresen megtörtént",
				warningPlatformModuleText: "Olyan platformot választott, ahol nem engedélyezett modul(ok) is vannak a projektben. A problémás modul(oka)t szürkével megjelöltük, s kérjük törölje ez(eke)t a projektből!",
				viewModuleSelectorBlockText: "Ahhoz, hogy a modulválasztó megjelenjen, kérjük adja meg a projekt nevét, illetve adja meg, hogy milyen nyelv(ek)en és platformon legyen elérhető!",
				addModuleSpecificSettingsText: "Állítson be minden olyan paramétert, amit ennél a modulnál fontosnak tart.",
				errorRemoveLogicalTriggerText: "Figyelem! Ez a trigger nem törölhető, mert logikai kapcsolatban áll egy másik triggerrel!",
            },
			views: {
				role: "Szabály nézet",
				calendar: "Naptár nézet",
				timeLine: "Idővonal nézet",
			},
            form: {
                labelAcro: "Projekt azonosító",
                labelName: "Projekt neve",
                labelDesc: "Projekt (belső) leírása. Még elérhető: {count} karakter.",
				labelLang: "Projekt beállított nyelvei",
				labelAppDesc: "Projekt applikációban megjelenő leírása",
                labelEndDate: "Befejezés dátuma",
                labelStartDate: "Kezdés dátuma",
                labelRegSurveys: "A projekt regisztrációs- vagy panel kérdőíve",
				labelUploadProjectImage: "A projekthez tartozó kép feltöltése",
                phAcro: "Projekt azonosító",
                phName: "Projekt neve",
                phDesc: "Projekt leírása",
				phSurv: "Válasszon ki egy kérdőívet...",
				phPlat: "Válasszon legalább egy platformot",
				phImageUpload: "Válassza ki a projekthez tartozó képet",
                btnAddToProject: "Hozzáadás a projekthez",
				phModuleImageUpload: "Válassza ki a modulhoz tartozó ikont vagy képfájlt",
            },
			infoCards: {
				addNewCard: "Új infó kártya hozzáadása",
				phIcon: "Itt adhatja meg az infó kártya ikonját (svg vagy png fájl)",
				phTitle: "Itt adhatja meg az infó kártya nevét",
				labelIcon: "Kérem adja meg az infó kártya ikonját",
				labelTitle: "Kérem adja meg az infó kártya nevét",
				labelSDate: "Az infó kártya megjelenésének kezdete (nem kötelező)",
				labelEDate: "Az infó kártya megjelenésének vége (nem kötelező)",
				labelSelectType: "Kérem adja meg az infó kártya méretét",
				tableTitle: "Az infó kártya neve",
				tableStartDate: "Az infó kártya megjelenésének kezdete",
				tableEndDate: "Az infó kártya megjelenésének vége",
				tableLanguage: "Az infó kártya nyelve",
				reallyRemoveInfoCard: "Biztosan törölni szeretné a kiválasztott infó kártyát?",
			},
            modal: {
                title: "A kiválasztott projekt törlése",
                moduleTitle: "A kiválasztott modul törlése",
                surveyTitle: "Kérdőív hozzáadása a projekthez",
                uploadTitle: "CSV fájl feltöltése az új felhasználókkal",
				smsTitle: "Az SMS modul beállítása",
				callTitle: "A hívás modul beállítása",
				audioTitle: "A hang modul beállítása",
				photoTitle: "A kép modul beállítása",
				videoTitle: "A videó modul beállítása",
				eventTitle: "Az esemény lekérdező modul beállítása",
				appUsageTitle: "Az app használat modul beállítása",
                locationTitle: "A lokáció modul beállítása",
                activateTitle: "Kiválasztott projekt aktívra állítása",
				dailyInfoTitle: "Napi adatok megmutatása",
                inactivateTitle: "A kiválasztott projekt passzívra állítása",
				imageModuleTitle: "A feltöltött kép megtekintése",
				removeImageTitle: "A kép törlésének megerősítése",
                loadTriggerTitle: "A trigger sablon betöltése",
                loadGoogleMapsTitle: "A lokációs adatok térképes megjelenítése",
                saveTriggerTitle: "A trigger beállítások mentése",
                deleteTriggerTitle: "A kiválasztott trigger sablon törlése",
				removeMediaFilesTitle: "A kiválasztott médiafájlok törlésének megerősítése",
				removeSurveyAnswersTitle: "A kiválasztott válaszok törlésének megerősítése",
				deleteLogicalTriggerTitle: "A logikai kapcsolatok törlésének megerősítése",
				deleteLogicalTriggerText: "Biztosan törölni szeretné a triggerek logikai kapcsolatait?",
				removeMediaFilesConfirmText: "Igen, biztosan törölni szeretném a kiválasztott média fájlokat!",
				removeSurveyAnswersConfirmText: "Igen, biztosan törölni szeretném a kiválasztott válaszokat!",
				removeMediaFilesAlertText: "Ne felejtse, hogy ez a törlés nem visszavonható. A kiválasztott fájlok végleg törlésre kerülnek a rendszerből!",
				removeSurveyAnswersAlertText: "Ne felejtse, hogy ez a törlés nem visszavonható. A kiválasztott válaszok és a hozzájuk tartozó média fájlok végleg törlésre kerülnek a rendszerből!",
				removeMediaFilesText: "Kérjük erősítse meg az alábbi fájlok törlését:",
				removeSurveyAnswersText: "Kérjük erősítse meg az alábbi válaszok törlését:",
				mathCaptchaText: "Kérjük oldja meg az alábbi egyszerű matematikai feladványt!",
                text: "Biztosan törölni szeretné a kiválasztott projektet?",
				urlPHText: "Az oldal neve, ahová szeretné beágyazni a kérdőívet (pl: oldalneve.com)",
                moduleText: "Biztosan törölni szeretné a kiválasztott modult a projetből?",
                surveyText: "Válasszon egy kérdőívet az alábbiak közül",
				surveyType: "A kérdőív típusa:",
				surveyExpire: "A kérdőív lejárata:",
				surveyUsedNotif: "Értesítő üzenetben tölthető ki a kérdőív",
				surveyEmbed: "Beágyazható más weboldalakba a kérdőív",
                uploadText: "Válasszon egy fájlt:",
                uploadPHText: "Adjon meg egy CSV fájlt...",
                uploadCancel: "Nincs importálás, mert a CSV-fájlban nem voltak új adatok.",
				uploadCancelMaxResponsers: "Nincs importálás, mert a CSV-fájlban található válaszadók száma meghaladja az ügyfél által lehetséges válaszadók számát.",
                uploadSuccess: "A CSV feltöltése és a felhasználók importja sikeres volt.",
				moduleAppText: "A modul infója, ami az appban jelenik meg:",
				moduleColorText: "A modul színe:",
				moduleShortText: "A modul rövid leírása:",
				removeImageText: "Biztosan törölni szeretné a képet?",
				moduleFontColorText: "A modul betűjének színe:",
                activateText: "Biztosan aktiválni szeretné ezt a projektet?",
                inactivateText: "Biztosan inaktiválni szeretné ezt a projektet?",
                loadTriggerText: "Válassza ki az alábbi listából azt a sablont, amit módosítani szeretne.",
                saveTriggerText: "Adja meg a trigger sablon nevét:",
                surveyModuleText: "Adja meg a kérdőív modul nevét (max 15 karakter)",
                confirmDeleteText: "Biztosan törölni szeretné a kiválasztott felhasználót a projektből?",
                confirmImportText: "Van legalább egy felhasználó a projekthez kapcsolva. Ha felhasználókat importál, akkor a jelenlegiek törlődni fognak.",
                locationModuleText: "Adja meg a helyszín modul nevét (max 15 karakter)",
                surveyModuleLabel: "A kérdőív modul neve",
				frequencyLabel: "Az adatfelvétel gyakorisága",
                freqRecordingLabel: "Az adatrögzítés gyakorisága",
                freqRecordingText: "Megadható adatok pl: 60 vagy 10:00; 11:00; 12:00 (stb.)",
				smsModuleLabel: "A SMS modul neve",
				audioModuleLabel: "A hang modul neve",
				photoModuleLabel: "A kép modul neve",
				videoModuleLabel: "A videó modul neve",
				phoneModuleLabel: "A telefonhasználat modul neve",
				eventModuleLabel: "Az esemény lekérdező modul neve",
				appUsageModuleLabel: "Az app használat modul neve",
                locationModuleLabel: "A lokációs modul neve",
                deleteTriggerText: "Biztosan törölni szeretné a kiválasztott triggert?",
                deleteTriggerGroupText: "Biztosan törölni szeretné a kiválasztott trigger csoportot?",
                deleteTriggerDefaultText: "Biztosan törölni szeretné a kiválasztott triggert?",
				tabAddNewRespondent: "Új válaszadó hozzáadása",
				tabSelectRespondent: "Meglévő válaszadó hozzáadása",
				addNewResponderName: "Adja meg az új válaszadó nevét",
				addNewResponderEmail: "Adja meg az új válaszadó email címét",
				phResponderName: "Itt adhatja meg az új felhasználó nevét",
				phResponderEmail: "Itt adhatja meg az új felhasználó email címét",
				phpResponderPass: "Adja meg a válaszadó jelszavát (nem kötelező)",
				phpResponderRePass: "Adja meg még egyszer a válaszadó jelszavát (nem kötelező)",
				lbEmailAddress: "Válassza ki az email címet a listából",
				successAddNewResponder: "Sikeresen hozzáadott egy új válaszadót a projekthez!",
				updateAddResponder: "Sikeresen hozzáadott egy meglévő válaszadót a projekthez!",
				pleaseChooseAnEmail: "Kérjük válasszon egy email címet a listából!",
				noMoreRespondents: "Nincs több hozzáadható válaszadó. Kérjük vegyen fel egy újat a másik fülön!",
				tableExportName: "Fájl neve",
				tableExportLastUpdated: "Exportálás dátuma",
				tableExportDownload: "Fájl letöltése",
				canFilterExportText: "Mivel használta a szűrőt, így lehetősége van csak a szűrt adatokat exportálni.",
				gpsAccurary: "Állítsa be be a GPS koordináták pontosságát",
				bitRateLabel: "Bitráta meghatározása:",
				sampleRateLabel: "Mintavételezés:",
				recordTimeLabel: "Felvétel ideje:",
				photoSizeLabel: "Kép mérete:",
				photoWidthHolder: "Kép x koordinátája",
				photoHeightHolder: "Kép y koordinátája",
				photoQualityLabel: "Kép minősége:",
				photoOrientedLabel: "Kép orientációja:",
				videoQualityLabel: "Videó minősége:",
				canRecordSoundLabel: "Hangrögzítés engedélyezése?",
				locationRequiredLabel: "Lokációs adatok (helykoordináta)",
            },
			results: {
				projectStartEndDates: "A projekt kezdete: {0}. A projekt befejezése: {1}",
				tabCheckDatas: "Beérkezett adatok ellenőrzése",
				tabDatasOnDiagram: "Adatok ábrázolása",
				resultDate: "Lekért időpont: {0}",
				exportDatas: "Moduladatok exportálása",
				resultDatas: "A felhasználó ennyi adatot küldött be ezen a napon: {0}",
				resultModuleName: "Modul neve: {0}",
				resultResponderName: "Válaszadó neve: {0}",
				missingUploads: "Mutassa azokat a válaszadókat, akik a héten még nem töltöttek fel adatot:",
				tableUser: "Válaszadó neve",
				tableNrcId: "NRCID",
				tableRegister: "Regisztráció ideje",
				tableEmailAddress: "Email cím",
				tableProgress: "Általános előrehaladás",
				tableDataProgress: "Heti adatok előrehaladása",
				textNoResult: "A megadott szűrési feltételeknek megfelelően nincs találat!",
			},
            sampling: {
                blocks: {
                    nameVars: "Változók",
                    nameStat: "Statisztika",
                    nameFilters: "Szűrők beállítása",
                    nameSampling: "További szűrések",
                    nameSelectedUsers: "Kiválasztott felhasználók",
                },
                codeeditor: {
                    optFilter: "Függvények",
                    optLogic: "Logikai operátorok",
                    lblCheck: "Vizsgálat",
                    helps: {
                        txtIs: "Az IS függvényt arra használjuk, hogy megállapítsuk, egy adott változó értéke meg van megadva vagy sem. PÉLDA: 'age' IS NULL -> ez azt jelenti, hogy azok a találatok érdekesek nekünk, akik nem adták meg az életkorukat. Ezt lehet tagadni is, PÉLDA: 'age' IS NOT NULL -> ez pedig azokat a felhasználókat fogja listázni, ahol az életkor adatot megadták.",
                        txtOr: "Az OR logikai változó célja, hogy akkor adjon vissza találatot, ha legalább 2 változó valamelyik értéke a feltételnek megfelel. PÉLDA: 'sex' = \"man\" OR 'age' < 30 -> ez azt jelenti, hogy azokra a találatokra vagyunk kíváncsiak, akik vagy férfiak, vagy 30 éven aluliak. Komplexebb PÉLDA: ('sex' = \"man\" AND 'age' < 25) OR ('sex' = \"man\" AND 'age' BETWEEN(25,50)) -> ez azt jelenti, hogy azok a találatok kellenek nekünk, akik férfiak ÉS 25 év alattiak, VAGY férfiak és 25 és 50 közt vannak.",
                        txtAnd: "Az AND logikai változó célja, hogy akkor adjon vissza találatot, amikor legalább 2 változó mindkét értéke a feltételeknek megfelelő. PÉLDA: 'sex' = \"woman\" AND 'age' BETWEEN(18,30) -> ez azt jelenti, hogy azok a felhasználók kellenek nekünk, akik nők és 18-30 év közöttiek.",
                        txtAny: "Az ANY függvényt akkor használjuk, hogyha egy adott változó értékének több megfeleltetési lehetősége is van. PÉLDA: eyecolor = ANY(\"brown\",\"blue\",\"green\") -> ez azt jelenti, hogy azok a felhasználók kellenek nekünk, akiknek a szeme színe barna, zöld vagy kék. Másik PÉLDA: eyecolor = NOT ANY(\"blue\", \"green\") -> ez azt jelenti, hogy azok a felhasználók kellenek nekünk, akiknek a szeme színe nem kék vagy zöld.",
                        txtMax: "A MAX függvényt akkor használjuk, hogyha olyan felhasználók kellenek nekünk, akik egy bizonyos értéket a legnagyobbra állítottak. PÉLDA: MAX(age) -> ez azt jelenti, hogy azok a felhasználók kellenek nekünk, akinek életkora a legmagasabb.  A függvény a legnagyobb értéket veszi alapul, így például ha sok 70 éves van az adatbázisban, akkor több, ha pedig csak egy 70 éves van, akkor csak egy fog listázódni.",
                        txtMin: "A MIN függvényt akkor használjuk, hogyha olyan felhasználók kellenek nekünk, akik egy bizonyos értéket a legkisebbre állítottak. PÉLDA: MIN(age) -> ez azt jelenti, hogy azok a felhasználók kellenek nekünk, akinek életkora a legkisebb. A függvény a legkisebb értéket veszi alapul, így például ha sok 20 éves van az adatbázisban, akkor több, ha pedig csak egy 20 éves van, akkor csak egy fog listázódni.",
                        txtNot: "A NOT logikai változót általában függvények előtt használhatjuk (az IS függvényt kivéve), ha valamit tagadni szeretnénk vele. PÉLDA: email NOT CONTAIN(\"%gmail%\") -> ez azt jelenti, hogfy azokra a felhasználókra vagyunk kíváncsiak, akik nem gmail-os email címmel regisztráltak. Komplexebb PÉLDA: age NOT BETWEEN(18,30) AND sex NOT CONTAIN(\"wo%\") -> ez azt jelenti, hogy azok a felhasználók kellenek nekünk, akik NEM 18-30 évesek ÉS NEM nők.",
                        txtNull: "A NULL paramétert az IS függvénnyel együtt használjuk, így lásd ennek a leírását.",
                        txtLimit: "A LIMIT függvényt akkor használjuk, hogyha a lekérdezett rekordok számát szeretnénk behatárolni. PÉLDA: LIMIT 9, 100 -> ez azt jelenti, h a lekérdezett rekordok 10. elemétől kezdve 100 elemet szeretnénk megjeleníteni csak.",
                        txtBetween: "A BETWEEN függvényt komplexebb lekérdezésekhez használjuk, ami használható más függvényekkel együtt. Célja az, hogy tömörebben megfogalmazzuk, milyen határértékek közt szeretnénk megjeleníteni találatokat. PÉLDA: age = BETWEEN(MIN(age) + 5, MAX(age) - 4) AND sex = \"WOMAN\" -> ez azt jelenti, hogy azokra a találatokra vagyunk kíváncsiak, akiknek az életkoruk 5-tel több, mint a minimum, illetve az életkoruk 4-gyel kevesebb, mint a maximum és nők. Ezt még egyszerűbben leírva, PÉLDA: age = BETWEEN(MIN(age) + 5, MAX(age) - 4) AND sex CONTAIN(\"WO%\")",
                        txtContain: "A CONTAIN függvényt akkor használjuk, hogyha azokra találatokra vagyunk kíváncsiak, amik egy adott string mintának megfeleltethetőek. PÉLDA: email CONTAIN(\"%tk.%\") -> ez azt jelenti, hogy azokra a felhasználókra vagyunk kíváncsiak, akiknek email címében szerepel a \"tk.\" kifejezés.",
                    },
                    statuses: {
                        noCode: "Várom a kód megadását.",
                        noSpace: "A kódban nincs szóköz. Kérjük pótolja.",
                        noResult: "A megadott feltételre nincs találat, kérjük módosítsa a kódot.",
                        allRight: "A beállított szűrőfeltétel jónak tűnik.",
                        loadedCode: "A múlt alkalommal használt, és most betöltött kód.",
                        errors: {
                            errorNotVar: "A kódban olyan változót használ, ami a \"Változók\" panelen nem szerepel.",
                            errorNotOperand: "A kódban nem találtam matematikai szimbólumot.",
                            errorNotEqualVar: "A kódban van olyan változóra való hivatkozás, amely nem egyezik a projektben használható változókkal.",
                            errorMissingParts: "A kódban van olyan változó, ahol nincs se matematikai szimbólum, se érték megadva.",
                            errorLogicOperands: "A kódban használ logikai műveletet, de nincs mögötte semmilyen kódrészlet.",
                            errorUseLimitFunc1: "A LIMIT függvény paramétereit vesszővel elválasztva kell meghatározni.",
                            errorUseLimitFunc2: "A LIMIT függvény 2 paramétere csak egész szám lehet.",
                            errorWrongBrackets: "A kódban zárójelek használata problémás, emiatt kérjük nézze át újra.",
                            errorFirstLimitFunc: "A LIMIT függvény nem lehet az első utasítás a kódban, csak az utolsó.",
                            errorWrongQuoteOnVar: "A kódban van olyan változó, ahol az idézőjelezést nem megfelelően használta.",
                            errorNotLastLimitFunc: "A LIMIT függvényt a kódban csak az utolsó helyen használhatja.",
                            errorWrongQuoteOnValue: "A kódban van olyan érték, ahol az idézőjelezést nem megfelelően használta.",
                            errorWrongISFunctionUse: "A kódban rosszul használja az IS funkciót. Kérjük ellenőrizze",
                            errorUseBetweenFuncParam: "A BETWEEN függvény mindkét paraméterében vagy számokat, vagy a MIN és MAX függvényeket használhatja csak.",
                            errorWrongFunctionOpenBracket: "A függvény után nem találom a \"(\" jelet, ami probléma.",
                        }
                    }
                },
                form: {
                    lblSeed: "A seed értéke",
                    lblIDSeq: "ID-k egymás után",
                    lblFirstLine1: "A kiválasztott válaszadók",
                    lblFirstLine2: "-a",
                    lblSecondLine1: "Pontosan",
                    lblSecondLine2: "számú válaszadó",
                    lblThirdLine1: "-tól",
                    lblThirdLine2: "-ig",
                },
                modal: {
                    colFirst: "A kérdés",
                    colSecond: "A tulajdonság",
                },
                btnAddNewVar: "Új változó hozzáadása",
                btnSaveSample: "A minta mentése",
                btnAddAllUsers: "Az összes felhasználó betöltése",
                btnResetFilters: "A szűrések resetelése",
                btnRefreshSample: "A minta frissítése",
            },
            modules: {
                surveyName: "Kérdőívek",
                surveyText: "Új kérdőív hozzáadása a projekthez",
                locName: "Helyszín",
                locText: "Lokációs modul hozzáadása",
                actName: "Aktivitás",
                actText: "Aktivitás modul hozzáadása"
            },
            usersTable: {
                titleName: "Név",
                titleEmail: "Email",
                titleRemove: "Törlöm"
            },
			logTable: {
				type: "A log típusa",
				desc: "A log leírása",
				cycles: "Mérési ciklus időpontja",
				created: "A log létrehozásának ideje"
			},
            surveyTable: {
                titleName: "Név",
                titleSurvey: "A kérdőív kiválasztása"
            },
            triggerTable: {
                titleName: "Sablon neve",
                titleTrigger: "Trigger kiválasztása",
                titleModuleName: "Az érintett modul",
                titleOperationName: "Trigger művelet",
            },
            validating: {
                name: "Adja meg a projekt nevét, melynek legalább 5 karakterből kell állnia",
                acronym: "Adja meg a projekt rövidítését, melynek legalább 2 karakterből kell állnia",
                endDate: "Adja meg a projekt befejezésének dátumát",
                endTime: "Adja meg a projekt befejezésének idejét",
                startDate: "Adja meg a projekt kezdetének dátumát",
                startTime: "Adja meg a projekt kezdetének idejét",
                desc: "Adja meg a projekt leírását, melynek legalább 10 karakterből kell állnia",
				nameResponder: "A válaszadó neve min. 5, max. 50 karakterből állhat",
            },
            messages: {
                newSuccess: "Az új projekt létrehozása sikeresen megtörtént.",
                updateSuccess: "A projekt adatainak módosítása sikeres"
            },
            triggers: {
                tabs: {
                    time: "Idő beállítása",
                    location: "Lokáció beállítása",
                    notification: "Értesítés beállítása",
					logicalConnection: "Logikai kapcsolatok összeállítása"
                },
				logicalBlocks: {
					time: "Idő triggerek",
					location: "Helyszín triggerek"
				},
				times: {
					set: "beállítás",
					withTimeSlot: "idősávval",
					withCustomTimeSlot: "testreszabott idősávval",
					default: "Alapbeállítások",
					timeSlot: "Idősávok meghatározása",
					startTimeSlot: "Idősáv kezdete",
					endTimeSlot: "Idősáv vége",
					color: "Színe",
					dateStart: "Dátum kezdete",
					timeStart: "Időpont kezdete",
					dateEnd: "Dátum vége",
					timeEnd: "Időpont vége",
					loadTemp: "Sablon betöltése",
					saveTemp: "Sablon mentése",
					removeRole: "A beállított dátumok alapján a meglévő szabály törlése",
					addAliasName: "Adja meg a trigger nevét (opcionális)",
					savedTriggers: "Már rögzített triggerek",
					setNewTrigger: "Új trigger beállítása",
					addGracePeriod: "Adja meg egy türelmi időt",
					saveGracePeriod: "Türelmi idő mentése",
					noTriggerSetting: "Még nincs rögzítve trigger szabály",
				},
                nots: {
					addPlace: "Adja meg egy helyet...",
					searchMap: "Keressen meg egy helyet, és jelölje meg a térképen",
					zoomDefault: "Nagyítás az alapértelmezett méretre",
                    blockTitle1: "Trigger választása",
                    blockTitle2: "Értesítés beállítása",
                    blockTitle3: "Már rögzített értesítések",
                    selectATrigger: "Válasszon egy triggert",
                    beforeNotification: "Értesítés a trigger kezdete előtt",
                    inActionNotification: "Értesítés a trigger működése alatt",
                    afterNotification: "Értesítés a trigger vége után",
                    beforeTime: "Mennyivel előtte?",
                    inActionTime: "Hányszor ismétlődjön?",
                    afterTime: "Mennyivel utána?",
                    pushNoti: "Mobil alapú Push értesítés",
                    emailNoti: "Email értesítés",
                    noNotiText: "Még nincs rögzítve értesítés",
                    addNewTriggerBtn: "Új trigger beállítása",
                    withMinute: "perccel",
                    withTimes: "alkalommal",
                    setTimeTrigger: "időtrigger beállítás",
                    setLocationTrigger: "lokáció trigger beállítás",
                    setupNotification: "értesítés beállítva",
					form: {
						titleUpTime: "Triggerfeltétel minimális működési ideje",
						titleAddPlace: "Helyszín hozzáadása",
						titleShortDesc: "Rövid leírás",
						titleDefaultSet: "Trigger alapbeállítások",
						titleTriggerType: "Adja meg a trigger típusát",
						titleBetweenTime: "Két trigger között eltelt minimális idő",
						titleDistanceFrom: "Távolság ettől a ponttól",
						titleLocationMove: "A helyszín mozgatható",
						titleSavedLocations: "Már rögzített helyszínek",
						btnNewLocation: "Új triggert szeretnék beállítani",
						textLocation: "helyszín trigger",
						textNoLocation: "Még nincs rögzítve helyszín",
						phOnlyNumber: "A mezőbe csak számok írhatók",
					}
                },
				logicTitle: "A triggerek egymással alapértelmezetten <strong>VAGYLAGOS</strong> kapcsolatban állnak. Ezen a felületen azt lehet megadni, hogy hol, milyen elemek között legyenek <strong>ÉS</strong> logikai kapcsolatok. Tehát egy modul csak akkor jelenhet meg vagy működhet, hogyha az idő- <strong>ÉS</strong> a helyszín triggerek feltételei teljesülnek.<br><strong>A piros színnel jelzett triggerek közt ÉS logikai kapcsolat van!</strong>",
            },
			diags: {
				title: "Projekt diagnosztikák",
				desc: "A kiválasztott projekthez tartozó diagnosztikák megjelenítése. A legfrissebb adatok a táblázat elején találhatók!",
				table: {
					name: "Válaszadó neve",
					diagType: "Diagnosztika típusa",
					diagDesc: "Diagnosztika leírása",
					created: "Létrehozás dátuma",
				}
			},
			disabled: "Ehhez a projekthez nincsen jogosultságod!",
            btnImport: "Válaszadók importálása",
			btnAddNewUser: "Új válaszadó hozzáadása",
            btnSamplingOpen: "Mintavételezés megnyitása",
            btnSamplingClose: "Mintavételezés bezárása",
			btnCreateNewExport: "Új CSV export fájl készítése",
            createNewProjectText: "Új projekt létrehozása",
            processNewProjectText: "Létrehozás folyamatban...",
			hasUploadedImage: "Már van feltöltve kép...",
        },
        survey: {
			tabs: {
				viewer: "Nézet",
				designer: "Tervező",
				settings: "Beállítások",
				flowchart: "Folyamatábra",
				variables: "Változók"
			},
			surveyTypes: {
				traditional: "Hagyományos kérdőív típus",
				traditionalDesc: "Itt szerkeszthetők az általános kérdőívek, ahol az összes funkció használható.",
				register: "Regisztrációs kérdőív típus",
				registerDesc: "Itt szerkeszthető a regisztrációs kérdőív, amelynek segítségével felhasználók adhatók a projektekhez.",
				panel: "Panel kérdőív típus",
				panelDesc: "Itt szerkeszthető a panel kérdőív, amellyel új válaszadók adhatók az adatbázishoz."
			},
            titles: {
                list: "Kérdőív szerkesztő",
                create: "Új kérdőív létrehozása",
                defaults: "Új kérdőív alapértelmezett adatai",
                untitle: "Kérdés szövege",
                undesc: "Kérdéshez tartozó leírás",
                unkey: "Adja meg a változó nevét, vagy használja az automatikusan létrehozottat.",
                selectType: "Válasszon egy kérdéstípust, és adjon hozzá egy új kérdést",
				defaultSurveySettings: "A kérdőív általános beállításai",
            },
            texts: {
                list: "A rendszerben elérhető kérdőívek.",
                create: "Itt állíthatók össze a kérdőívek. A kérdések sorrendje drag & drop módon változtatható.",
                selector: "Válassza ki a szerkeszteni kívánt kérdőív típusát.",
				autoTranslateText: "A rendszer képes arra, hogy többnyelvű kérdőívek esetén automatikusan fordítást készítsen. Alapértelmezésben ez a funkció be van kapcsolva. Amennyiben nincs rá szüksége, itt kikapcsolhatja.",
				autoTranslateTitle: "Automatikus fordítás bekapcsolása",
				autoTranslateSuccess: "A szöveg automatikus fordítása sikeresen megtörtént.",
            },
			labels: {
				answerName: "Adja meg a válaszlehetőséget",
				answerLabel: "Válasz címkéje",
				labelNextQuestion: "Következő kérdés",
				respondentsNumLabel: "válaszadó kiválasztva",
				selectRespondentLabel: "Válassz legalább egy válaszadót...",
			},
            hints: {
				notRemove: "Nem törölhető, mert legalább egy projekthez tartozik.",
                addNewQuestion: "Új kérdés hozzáadása",
				successSettings: "Sikeresen beállította a kérdőívet. A tervező fül mostantól aktív.",
				warningDefaultCode: "Figyelem! A kérdés változója alapértelmezett állapotban van. Kérjük módosítsa! (Engedélyezett karakterek: betű, szám és _ karakter.)",
				warningDefaultSurveyName: "Figyelem! A kérdőív nevét meg kell adni.",
				warningDefaultSurveyCode: "Figyelem! A kérdőv rövid nevét módosítani kell, mert alapértelmezett.",
				warningDefaultAddedCode: "Figyelem! Módosítsa a kérdés nevét és változóját, mivel az egy meglévő kérdés alapján lett létrehozva.",
				warningSurveySpecialCodes: "Figyelem! A kérdőív rövidítése csak betűket és számokat tartalmazhat!",
				warningWrongCode: "Kérjük ne használjon a változóban kettőnél több _ karaktert!",
				warningChooseLang: "Kérjük legalább egy nyelvet állítson be!",
				errorCodeExists: "A megadott kód már létezik, ezért kérjük válasszon másikat!",
				errorQuestionType: "Az URL-ben megadott paraméter nem egyezik meg a kérdőív típusával!"
            },
            modals: {
                title: "A kiválasztott kérdőív törlésének megerősítése",
                text: "Biztosan törölni szeretné ezt a kérdőívet?",
                warningTitle: "Figyelem! A művelet nem hajtható végre!",
                warningText: "A kiválasztott kérdőív jelenleg egy aktív projekthez tartozik, ezért nem törölhető. Ha törölni szeretné a kérdőívet, akkor előtte törölje azt a projektből.",
				changeTypeText: "Amennyiben végre szeretné hajtani ezt a folyamatot, az eddigi beállításai, a kérdésre adható válaszok (ha vannak) törlődni fognak. Ez a folyamat nem vonható vissza!",
				changeTypeTitle: "Figyelem! A kérdés típusának változtatására készül",
                removeAnswerTitle: "A kiválasztott válasz törlésének megerősítése",
                removeQuestionTitle: "A kiválasztott kérdés törlésének megerősítése",
                removeQuestionText: "Biztosan törölni szeretné ezt a kérdést? Ha igen, akkor az összes hozzá tartozó válasz is törlődni fog.",
                removeAnswerText: "Biztosan törölni szeretné ezt a választ?",
            },
			options: {
				title: "Beállítások",
				required: "Kötelező",
				multiple: "Több válaszlehetőség",
				randomize: "Véletlenszerű",
				other: "Egyéb, éspedig",
				dontknow: "Nem tudom",
				notanswer: "Nem válaszol",
			},
			questionTypes: {
				radio: "Radio gombok",
				checkbox: "Checkboxok",
				longText: "Hosszú szöveg",
				shortText: "Rövid szöveg",
				number: "Szám",
				email: "Email cím",
				phoneNumber: "Telefonszám",
				date: "Dátum",
				time: "Idő",
				dateTime: "Dátum és idő",
				audio: "Hangfeltöltés",
				video: "Videófeltöltés",
				photo: "Képfeltöltés",
			},
			settingMenus: {
				default: "Általános beállítások",
				view: "Megjelenés",
				import: "Importálás",
				export: "Exportálás",
				chooseMenu: "Kérlek válasszon egy lehetőséget",
			},
			fullTypes: {
				blockChoices: "Választások",
				blockRatings: "Rangsorolások és értékelések",
				blockBlocks: "Blokkok",
				blockTexts: "Szövegek",
				blockDates: "Dátumok és idők",
				blockUploads: "Feltöltések",
				blockContacts: "Kapcsolati adatok",
				radio: "Radio gombok",
				checkbox: "Checkboxok",
				longText: "Hosszú szöveg",
				shortText: "Rövid szöveg",
				number: "Szám",
				email: "Email cím",
				phoneNumber: "Telefonszám",
                website: "Weboldal",
				date: "Dátum",
				time: "Idő",
				dateTime: "Dátum és idő",
                pictureChoice: "Képválasztó",
                yesNo: "Igen / Nem",
                matrix: "Mátrix",
                opinionScale: "Véleményskála",
                likertScale: "Likert-skála",
                ranking: "Rangsorolás",
                rating: "Értékelés",
                textBlock: "Szöveg blokk",
                pictureBlock: "Kép blokk",
                videoBlock: "Videó blokk",
                soundBlock: "Hang blokk",
                fileUpload: "Fájlfeltöltés",
                videoUpload: "Videófeltöltés",
                photoUpload: "Képfeltöltés",
                soundUpload: "Hangfeltöltés",
			},
			types: {
				numInt: "Egész szám",
				numReal: "Valós szám",
				numLabel: "Válassza ki a megadni kívánt szám típusát",
				labelName: "A címke neve",
				textLabel: "Adja meg a karakterek maximális hosszát",
				phoneLabel: "Válassza ki, hogy melyik országkód alapján validáljuk a telefonszámot",
				textWarning: "tehát a megadható maximális karakter: {count}",
				commentLabel: "Szeretne hozzászólást engedélyezni a felhasználó számára?",
				textNoSettings: "Az adott kérdéstípusnak nincsenek egyéb beállítási lehetőségei.",
				recordTimeLabel: "Adja meg a felvétel maximális idejét",
				recordTimeWarning: "tehát {count} másodperc",
			},
            settings: {
                main: {
                    phName: "Kérdőív neve (max. 100 karakter)",
                    phAcro: "Kérdőív rövid neve (max. 20 karakter)",
                    phDesc: "Kérdőív leírása (max. 255 karakter)",
                    surveyName: "Adja meg a kérdőíve nevét",
                    surveyAcro: "Adja meg a kérdőíve rövid nevét, aminek egyedinek kell lennie",
                    surveyDesc: "Adja meg a kérdőíve leírását",
                    surveyLang: "Válassza ki, hogy milyen nyelveken szeretné a kérdőívet használni?",
                },
                validating: {
                    surveyName: "Kérjük adja meg a kérdőív nevét (5-100 karakter)",
                    surveyAcro: "Kérjük adja meg a kérdőív rövid nevét. (Egyedi azonosító, 3-20 karakter)",
                    surveyDesc: "Kérjük adja meg a kérdőív leírását (10-255 karakter",
                    codeAlreadyExists: "Ez a kód már létezik az adatbázisban.",
					codeExceptsChars: "A megadott kódban vannak olyan karakterek, amelyek nem engedélyezettek.",
                },
            },
            dropdown: {
                name: "Funkciók",
                add: "Új kérdés hozzáadása",
                set: "Beállítások",
                del: "Törlés"
            },
            answers: {
                text: 'Rövid szöveges válasz',
            },
			errors: {
				server: 'Szerver oldali hiba',
				wrongAddedCode: 'Abban az esetben nem tud kérdést hozzáadni, amikor már korábban ezt megtette, de a kérdés neve és a kérdéskód nem lett átírva.',
				wrongCopiedCode: 'Abban az esetben nem tud másolni egy kérdést, amikor már korábban ezt megtette, de a kérdés neve és a kérdéskód nem lett átírva.',
			},
            btnCopy: "A kérdőív másolása",
			allTypes: "Az összes kérdéstípus",
            defaultDesc: "Nincs leírás...",
            defaultTitle: "Nincs cím...",
			questionValue: "A kérdés változója",
			btnAddNewSection: "Új szakasz hozzáadása",
            createNewSurveyText: "Új kérdőív létrehozása",
        },
		textcontents: {
			titles: {
				editName: "Egy szöveges tartalom szerkesztése",
				editDesc: "Az űrlap segítségével állítható össze új szöveges tartalom, vagy egy már meglévő módosítható",
				listName: "Szöveges tartalmak",
				listDesc: "A rendszerben elérhető szöveges tartalmak",
			},
			tableList: {
				title: "Tartalom címe",
				removeText: "Tartalom törlésének státusza",
				removable: "Törölhető",
				notRemovable: "Nem törölhető",
			},
			form: {
				lbName: "Tartalom címe",
				phName: "Adja meg a tartalom címét",
				lbDelete: "A tartalom törölhető",
				lbContent: "A tartalom",
			},
			validating: {
				title: "A tartalom neve legalább 4, maximum 100 karakterből álljon",
				desc: "A szöveges tartalom legalább 10 karakterből kell, hogy álljon",
				noContent: "Ne felejtse el kitölteni a többi fordítást se!",
			},
			modal: {
				deleteText: "Biztosan törölni szeretné a kívánt szöveges tartalmat? A művelet nem vonható vissza!",
				deleteTitle: "A szöveges tartalom törlésének megerősítése",
			},
			btnAdd: "Új szöveges tartalom hozzáadása",
			saveSuccess: "A szöveges tartalom mentése sikeresen megtörtént",
			removeSuccess: "A szöveges tartalom törlése sikeresen megtörtént",
		},
        articleeditor: {
            titleName: "Cikk címe",
            statusName: "Cikk státusza",
            titles: {
                list: "Cikkszerkesztő",
                edit: "Egy cikk szerkesztése",
            },
            descs: {
                list: "A frontend rendszerhez hozzáadott cikk tartalma.",
                edit: "A cikk tartalmának módosítása.",
                upload: "Ha szeretné, fel tud tölteni egy új képet a cikk számára.",
                phUpload: "Adjon meg egy .png vagy .svg fájlt a cikk fotójának módosításához.",
            },
            messages: {
                errorEditor: "A kérdést és a választ angol és magyar nyelven is meg kell adni.",
                uploadSuccess: "A kép feltöltése sikeresen megtörtént",
                updateSuccess: "A cikk módosítása sikeresen megtörtént.",
                updateStatusSuccess: "A cikk státuszának módosítása sikeresen megtörtént.",
            },
        },
        faqeditor: {
            titles: {
                add: "GYIK hozzáadása",
                list: "GYIK szerkesztő",
                edit: "Egy GYIK szerkesztése",
            },
            descs: {
                add: "Az űrlap segítségével új GYIK-et adhat hozzá a rendszerhez.",
                list: "A rendszerhez eddig hozzáadott GYIK tartalom.",
                edit: "A GYIK tartalmának módosítása."
            },
            form: {
                phId: "Adja meg a GYIK rövid azonosítóját (mint pl: question-one)",
                phTitle: "Adja meg a kérdést (min. 5 karakter)",
                phDesc: "Adja meg a választ (min. 10 karakter)",
                labelId: "GYIK azonosító",
                labelTitle: "A kérdés",
                labelDesc: "Válasz a kérdésre",
                labelActive: "A GYIK státuszának beállítása"
            },
            messages: {
                errorEditor: "A kérdést és a választ angol és magyar nyelven is meg kell adni.",
                saveSuccess: "A mentés sikeresen megtörtént.",
                deleteSuccess: "A törlés sikeresen megtörtént.",
                updateSuccess: "A módosítás sikeresen megtörtént.",
                updateStatusSuccess: "A státusz módosítása sikeresen megtörtént.",
            },
            modal: {
                title: "Kiválasztott GYIK törlésének megerősítése",
                text: "Biztosan törölni szeretnéd a kiválasztott GYIK-et?"
            },
            faqIdName: "GYIK Azonosító",
            faqTitleName: "Kérdés",
            faqActivated: "GYIK státusza",
        },
        octres: {
            titleName: "Kutató neve",
            titles: {
                list: "Octopus kutatói",
                edit: "Kutató szerkesztése",
                fileUp: "Ha szeretné, töltsön fel egy új képet.",
                fileAct: "Aktuális kép."
            },
            descs: {
                list: "Az Octopus kutatói.",
                edit: "A kutató adatainak szerkesztéséhez használja az alábbi űrlapot."
            },
            form: {
                phpPos: "Adja meg a kutató pozícióját (min 5 karakter)",
                phTitle: "Adja meg a kutató nevét (min 5 karakter)",
                phUpload: "Adjon meg egy .png vagy .svg fájlt a kutató fényképének módosításához",
                phDesc: "Adja meg a kutató leírását (min 10 karakter)",
                labelPos: "Kutató pozíciója:",
                labelTitle: "Kutató neve:",
                labelDesc: "Kutató leírása:"
            },
            messages: {
                errorEditor: "Az adatokat angolul és magyarul is meg kell adni.",
                uploadSuccess: "Kép feltöltése sikeresen megtörtént",
                updateSuccess: "Kutató adatai sikeresen módosultak.",
            },
        },
        nlsubs: {
            title: "Hírlevélre feliratkozottak",
            text: "Hírlevélre feliratkozók, akik ezt a frontend oldalon tették meg.",
            table: {
                email: "Email cím",
                createdat: "Regisztráció dátuma"
            }
        },
        ressubs: {
            title: "Kutatásra feliratkozottak",
            text: "A kutatásra feliratkozók, akik ezt a frontend oldalon tették meg.",
            table: {
                fname: "Keresztnév",
                lname: "Vezetéknév",
                email: "Email cím",
                phone: "Telefonszám",
                createdat: "Regisztráció dátuma"
            }
        }
    }
}
